/* Coffee Cruise — prenumeratos konfiguratorius.
   Duomenys skaitomi is serveryje surenderintu korteliu (data- atributai).

   PASIRINKIMO MODELIS: state.selBy[formatas] = [{ k: variantId, n: kiekis }]
   Kiekvienas irasas turi SAVO kieki, todel "3 pakuotes vienos kavos" yra
   isreiskiama. Kiekis nebera atskiras valdymas — jis yra sumа. Niekas
   niekada netyliai neismetama: nera nei shift(), nei pop().

   KAINA: tik is selling plano per_delivery_price, sudedant pd * n.
   Jokios procentu aritmetikos — todel eiluciu sumos visada sutampa su bendra. */
(function () {
  "use strict";

  var root = document.querySelector("[data-pren]");
  if (!root) return;

  var GRAMS_PER_CUP = 7;
  var DAYS_PER_MONTH = 30.4;
  var MON = ["sausio", "vasario", "kovo", "balandžio", "gegužės", "birželio",
    "liepos", "rugpjūčio", "rugsėjo", "spalio", "lapkričio", "gruodžio"];
  var WD = ["sekmadienį", "pirmadienį", "antradienį", "trečiadienį",
    "ketvirtadienį", "penktadienį", "šeštadienį"];

  function warnBox(msg) {
    var box = document.createElement("div");
    box.className = "pren-warn";
    box.style.margin = "20px auto";
    box.style.maxWidth = "900px";
    box.textContent = msg;
    root.insertBefore(box, root.firstChild);
  }
  if (!getComputedStyle(root).getPropertyValue("--ink").trim()) {
    console.error("[prenumerata] pren.css neuzsikrove");
    warnBox("Stilių failas pren.css neužsikrovė, todėl išdėstymas atrodo sulūžęs.");
  }

  var el = {};
  /* lipnios juostos būsena (render() įrašo, barVisibility() naudoja) */
  var BAR = { ready: false, net: null, base: 0, formSeen: true };
  ["fmtHint", "pickHint", "picks", "sumTitle", "sumSub", "base", "disc", "total",
    "month", "kilo", "year", "when", "cta", "warn",
    "qtyTotal", "qtyCap", "tierHint", "giftHint", "barProg", "barSub", "barPct", "calcOut", "calcOpts", "filterCount",
    "ctaLabel", "ctaPrice", "status",
    "badge", "review", "navHint", "back", "next", "prog",
    "sum", "sheet", "sheetLabel", "sheetPanel", "sheetMeta", "nav",
    "base2", "total2", "barThumbs", "toForm", "calcApply", "ship",
    "advice", "setOpts", "setOut", "undo", "quiz", "quizToggle", "quizGo", "done", "shipbox", "modes", "picker"
  ].forEach(function (k) { el[k] = root.querySelector("[data-pren-" + k + "]"); });

  /* Riba — kilogramais (pupelės 1 kg, malta 250 g: 4 maltos = 1 kg). Pakuočių
     riba skaičiuojama pagal formatą: maxQ(). */
  var MAXKG = parseFloat(root.getAttribute("data-maxkg")) || 10;
  function maxQ() { return Math.max(1, Math.floor(MAXKG * 1000 / formatGrams())); }

  /* KAINOS PAKOPOS: nuolaida priklauso nuo bendro siuntos svorio. Planai
     Shopify — po vieną kiekvienai pakopai ir dažniui; čia tik parenkamas
     tinkamas. Mažiau nei 1 kg — kaip 1 kg (žemiausia pakopa). */
  var TIERS = [{ kg: 4, pct: 40 }, { kg: 3, pct: 35 }, { kg: 2, pct: 30 }, { kg: 0, pct: 25 }];
  function tierFor(kg) {
    for (var i = 0; i < TIERS.length; i++) if (kg + 1e-9 >= TIERS[i].kg) return TIERS[i];
    return TIERS[TIERS.length - 1];
  }
  function curKg() { return shipmentGrams() / 1000; }
  function tierPct() { return tierFor(curKg()).pct; }
  /* kita pakopa: kiek dar kg trūksta ir kokia bus nuolaida */
  function nextTier() {
    var kg = curKg(), cur = tierFor(kg), nx = null;
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (TIERS[i].pct > cur.pct) { nx = TIERS[i]; break; }
    }
    if (!nx) return null;
    return { pct: nx.pct, needKg: Math.max(0, nx.kg - kg) };
  }
  var declared = parseInt(root.getAttribute("data-count") || "-1", 10);
  var CUR = root.getAttribute("data-currency") || "EUR";
  var LOC = (root.getAttribute("data-locale") || "lt") === "lt" ? "lt-LT" : root.getAttribute("data-locale");

  var moneyFmt;
  try {
    var nf = new Intl.NumberFormat(LOC, { style: "currency", currency: CUR });
    moneyFmt = function (c) { return nf.format(c / 100); };
  } catch (e) {
    moneyFmt = function (c) { return (c / 100).toFixed(2).replace(".", ",") + " €"; };
  }
  function money(c) { return isFinite(c) ? moneyFmt(c) : "—"; }

  /* Nemokamo siuntimo slenkstis eurais is sekcijos nustatymo; turi sutapti su
     parduotuves siuntimo nustatymais. Lyginama su suma uz siunta (centais). */
  var FREESHIP = Math.round((parseFloat(root.getAttribute("data-freeship")) || 0) * 100);
  function shipText(net) {
    /* slenkstis 0 — pristatymas visada nemokamas */
    if (!FREESHIP) return "Pristatymas Lietuvoje nemokamas";
    if (!isFinite(net)) return "";
    return net >= FREESHIP
      ? "Siuntimas Lietuvoje nemokamas"
      : "Iki nemokamo siuntimo trūksta " + money(FREESHIP - net);
  }
  function kgText(g) { return String(Math.round(g / 10) / 100).replace(".", ",") + " kg"; }

  /* Lietuviska daugybine forma: 1 pakuote, 2 pakuotes, 11 pakuociu. */
  function pl(n, sg, plNom, plGen) {
    var t = n % 10, h = n % 100;
    if (t === 1 && h !== 11) return sg;
    if (t === 0 || (h >= 11 && h <= 19)) return plGen;
    return plNom;
  }
  function packs(n) { return n + " " + pl(n, "pakuotė", "pakuotės", "pakuočių"); }
  /* galininkas mygtukams: "Siųsti 5 pakuotes" */
  function packsAcc(n) { return n + " " + pl(n, "pakuotę", "pakuotes", "pakuočių"); }
  /* atskiru kavu skaicius vadinamas rusimis: "4 pakuotes, 2 rusys" */
  function kinds(n) { return n + " " + pl(n, "rūšis", "rūšys", "rūšių"); }

  var TASTE_LT = { chocolate: "Šokoladinė", fruit: "Vaisinė", caramel: "Karamelinė", nut: "Riešutinė" };

  /* Ikonos: vienos linijos, be uzpildu — kaip pasirinkimu plytelese. */
  var SVG_HEAD = '<svg viewBox="0 0 22 22" width="20" height="20" aria-hidden="true" ' +
    'focusable="false" fill="none" stroke="currentColor" stroke-width="1.2">';
  var ICO = {
    beans: '<ellipse cx="8.4" cy="9" rx="4.1" ry="5.6" transform="rotate(-28 8.4 9)"></ellipse>' +
      '<path d="M6.7 4.5c1.6 2.6 1.9 6-.6 9"></path>' +
      '<ellipse cx="14" cy="13.6" rx="4.1" ry="5.6" transform="rotate(-28 14 13.6)"></ellipse>' +
      '<path d="M12.3 9.1c1.6 2.6 1.9 6-.6 9"></path>',
    ground: '<path d="M4.5 6h13l-2.2 10.4a1.6 1.6 0 0 1-1.6 1.3H8.3a1.6 1.6 0 0 1-1.6-1.3z"></path>' +
      '<path d="M3.4 6h15.2"></path>' +
      '<path d="M8.7 10.6h.01M11 12.4h.01M13.3 10.6h.01M9.8 14.2h.01M12.2 14.2h.01" stroke-width="1.6" stroke-linecap="round"></path>',
    box: '<path d="M2.6 6.6 11 3l8.4 3.6v8.8L11 19l-8.4-3.6z"></path>' +
      '<path d="M2.6 6.6 11 10.2l8.4-3.6M11 10.2V19"></path>',
    truck: '<path d="M2.6 6.4h9.2v8.2H2.6z"></path><path d="M11.8 9.2h3.6l2.6 2.8v2.6h-6.2z"></path>' +
      '<circle cx="6.2" cy="16.4" r="1.6"></circle><circle cx="15.2" cy="16.4" r="1.6"></circle>',
    pause: '<circle cx="11" cy="11" r="7.6"></circle><path d="M9.2 8.2v5.6M12.8 8.2v5.6"></path>',
    cancel: '<circle cx="11" cy="11" r="7.6"></circle><path d="M8.2 8.2l5.6 5.6M13.8 8.2l-5.6 5.6"></path>'
  };
  function icoEl(name, cls) {
    var s = document.createElement("span");
    s.className = cls || "pren-ico";
    s.innerHTML = SVG_HEAD + (ICO[name] || "") + "</svg>";
    return s;
  }

  function norm(s) {
    s = String(s || "").toLowerCase();
    var map = { "ą": "a", "č": "c", "ę": "e", "ė": "e", "į": "i", "š": "s", "ų": "u", "ū": "u", "ž": "z" };
    var out = "";
    for (var i = 0; i < s.length; i++) out += (map[s.charAt(i)] || s.charAt(i));
    return out;
  }

  var lastStatus = "", statusTimer = 0;
  function say(msg) {
    if (!el.status || !msg || msg === lastStatus) return;
    lastStatus = msg;
    if (statusTimer) clearTimeout(statusTimer);
    statusTimer = setTimeout(function () { el.status.textContent = msg; }, 150);
  }

  /* ---------- duomenys ---------- */
  var ITEMS = [];
  Array.prototype.forEach.call(root.querySelectorAll(".pren-coffee"), function (node) {
    var o = node.getAttribute("data-o");
    var vid = parseInt(node.getAttribute("data-vid"), 10) || 0;
    if (!o || !vid) return;
    var im = node.querySelector("img");
    var sp = [];
    (node.getAttribute("data-sp") || "").split(";").forEach(function (c) {
      if (!c) return;
      var b = c.split("~"), id = parseInt(b[0], 10);
      /* id~kaina~nuolaida%~pavadinimas */
      var nm = b.slice(3).join("~");
      if (id) sp.push({ id: id, pd: parseInt(b[1], 10), pct: parseFloat(b[2]) || 0, n: nm, days: daysFromLabel(nm) });
    });
    var g = parseFloat(node.getAttribute("data-g"));
    ITEMS.push({
      k: String(vid),
      o: o,
      f: node.getAttribute("data-f") === "ground" ? "ground" : "beans",
      p: parseInt(node.getAttribute("data-p"), 10) || 0,
      vid: vid,
      g: (isFinite(g) && g > 0) ? g : 0,
      blend: node.getAttribute("data-blend") === "1",
      decaf: /decaf/i.test(o),
      str: node.getAttribute("data-str") || "",
      ra: parseFloat((node.getAttribute("data-rv") || "0|0").split("|")[0]) || 0,
      rn: parseInt((node.getAttribute("data-rv") || "0|0").split("|")[1], 10) || 0,
      taste: (node.getAttribute("data-taste") || "").split(/\s+/).filter(Boolean),
      note: node.getAttribute("data-note") || "",
      fullEl: node.querySelector(".pren-coffee-full"),
      big: node.getAttribute("data-big") || "",
      url: node.getAttribute("data-url") || "",
      img: im ? im.getAttribute("src") : "",
      el: node,
      pick: node.querySelector(".pren-coffee-pick"),
      qtyOut: node.querySelector("[data-cq-out]"),
      sp: sp
    });
  });
  if (!ITEMS.length) {
    warnBox("Konfigūratorius neužsikrovė: nerasta kavų. Liquid suskaičiavo " + declared + ".");
    return;
  }

  /* Indeksuojam pagal VARIANTO ID, ne pagal kilme: dvi tos pacios salies
     kavos nebesusilieja i viena iraso ir nebededa i krepseli ne to varianto. */
  var BY = { beans: {}, ground: {} };
  var ORIG = { beans: {}, ground: {} };
  var ORDER = { beans: [], ground: [] };
  ITEMS.forEach(function (it) {
    BY[it.f][it.k] = it;
    ORDER[it.f].push(it.k);
    var nk = norm(it.o);
    if (!ORIG[it.f][nk]) ORIG[it.f][nk] = it.k;
  });

  var PLAN_MODE = !!root.querySelector('input[name="pren-plan"]');

  /* Grazina null, kai pavadinime nera laiko vieneto — tada datos ir
     menesio kaina rodomos kaip "—", o ne isgalvojamos. */
  function daysFromLabel(txt) {
    var t = norm(txt).replace(/\d+\s*%/g, " ");
    var unit = 0;
    if (/savait|week/.test(t)) unit = 7;
    else if (/menes|month/.test(t)) unit = 30;
    else if (/dien|day/.test(t)) unit = 1;
    else if (/metus|metai|year/.test(t)) unit = 365;
    if (!unit) return null;
    var m = t.match(/(\d+)\s*(?:savait|week|menes|month|dien|day|metus|metai|year)/);
    var k = m ? (parseInt(m[1], 10) || 1) : 1;
    return unit * k;
  }
  function checkedPlanInput() { return root.querySelector('input[name="pren-plan"]:checked'); }

  function ltWeeks(k) { return k === 1 ? "Kas savaitę" : "Kas " + k + " " + pl(k, "savaitę", "savaites", "savaičių"); }
  function ltMonths(k) { return k === 1 ? "Kas mėnesį" : "Kas " + k + " " + pl(k, "mėnesį", "mėnesius", "mėnesių"); }
  function ltDays(k) { return k === 1 ? "Kas dieną" : "Kas " + k + " " + pl(k, "dieną", "dienas", "dienų"); }
  function ltLabelFromDays(d) {
    if (!d) return "";
    if (d % 30 === 0) return ltMonths(d / 30);
    if (d % 7 === 0) return ltWeeks(d / 7);
    return ltDays(d);
  }
  /* Siuntu per metus skaicius imamas is laiko VIENETO, ne is dienu: menesinis
     planas siunciamas 12, o ne 12,2 karto per metus. Skaiciuojant per dienas
     atsirasdavo ~1,5% klaida menesio kainoje. */
  function shipmentsPerYearNum(d) {
    if (!d) return 0;
    if (d % 30 === 0) return 12 / (d / 30);
    if (d % 7 === 0) return 52 / (d / 7);
    if (d % 365 === 0) return 1 / (d / 365);
    return 365 / d;
  }
  function shipmentsPerYear(d) {
    var n = shipmentsPerYearNum(d);
    if (!n) return "";
    n = Math.round(n * 10) / 10;
    var whole = Math.round(n);
    var txt = (Math.abs(n - whole) < 0.05) ? String(whole) : String(n).replace(".", ",");
    return txt + " " + pl(whole, "siunta", "siuntos", "siuntų") + " per metus";
  }

  /* Ikona pagal intervala: savaites — 2 ženklai kalendoriuje, menesis — 1,
     ilgesnis nei menesis — 1 su rodykle. Bendras kalendoriaus remas tas pats,
     kad plyteles atrodytu vienos serijos. */
  function freqIcon(d) {
    var head = '<rect x="3.2" y="4.8" width="15.6" height="13.4" rx="1.4"></rect>' +
      '<path d="M3.2 8.6h15.6M7.4 3.2v3M14.6 3.2v3"></path>';
    var marks;
    if (!d) marks = '<path d="M8 13.4h6" stroke-linecap="round"></path>';
    else if (d <= 10) marks = '<circle cx="7.6" cy="12.2" r="1.1" fill="currentColor" stroke="none"></circle>' +
      '<circle cx="11" cy="15.2" r="1.1" fill="currentColor" stroke="none"></circle>' +
      '<circle cx="14.4" cy="12.2" r="1.1" fill="currentColor" stroke="none"></circle>';
    else if (d <= 20) marks = '<circle cx="8.6" cy="13.6" r="1.2" fill="currentColor" stroke="none"></circle>' +
      '<circle cx="13.4" cy="13.6" r="1.2" fill="currentColor" stroke="none"></circle>';
    else if (d <= 40) marks = '<circle cx="11" cy="13.6" r="1.3" fill="currentColor" stroke="none"></circle>';
    else marks = '<circle cx="9.2" cy="13.6" r="1.2" fill="currentColor" stroke="none"></circle>' +
      '<path d="M12.2 13.6h3.4m-1.3-1.3 1.3 1.3-1.3 1.3" stroke-linecap="round"></path>';
    return '<svg class="pren-choice-ico" viewBox="0 0 22 22" width="22" height="22" aria-hidden="true" ' +
      'focusable="false" fill="none" stroke="currentColor" stroke-width="1.2">' + head + marks + '</svg>';
  }

  function localisePlans() {
    var seen = {};
    Array.prototype.forEach.call(root.querySelectorAll('input[name="pren-plan"]'), function (inp) {
      var raw = inp.getAttribute("data-raw") || "";
      var d = daysFromLabel(raw);
      inp.setAttribute("data-days", d === null ? "" : String(d));
      var lab = d === null ? raw : ltLabelFromDays(d);
      inp.setAttribute("data-lt", lab);
      var lb = inp.parentNode;
      var slot = lb.querySelector(".pren-choice-icoslot");
      if (slot && !slot.firstChild) slot.innerHTML = freqIcon(d);
      var main = lb.querySelector(".pren-choice-main");
      var sub = lb.querySelector(".pren-choice-sub");
      if (main) main.textContent = lab;
      if (sub) {
        if (d === null) { sub.textContent = ""; sub.hidden = true; }
        else { sub.hidden = false; sub.textContent = shipmentsPerYear(d); }
      }
      /* planų yra po vieną kiekvienai pakopai — dažnis rodomas vieną kartą,
         nuolaida parenkama pagal kiekį */
      lb.hidden = !!seen[lab];
      if (lb.hidden && inp.checked) inp.checked = false;
      seen[lab] = true;
    });
  }

  /* dovanos pagal kiekį (layout/theme.liquid → script[data-pren-gifts]) */
  var GIFTS = [];
  try {
    var gEl0 = document.querySelector("script[data-pren-gifts]");
    if (gEl0) GIFTS = (JSON.parse(gEl0.textContent || "[]") || []).sort(function (a, b) { return a.kg - b.kg; });
  } catch (e) { GIFTS = []; }
  function giftsFor(kg) { return GIFTS.filter(function (g) { return kg + 1e-9 >= g.kg; }); }
  function giftHintText() {
    if (!GIFTS.length) return "";
    var kg = curKg(), got = giftsFor(kg), nx = null;
    for (var i = 0; i < GIFTS.length; i++) if (kg + 1e-9 < GIFTS[i].kg) { nx = GIFTS[i]; break; }
    var a = got.length ? "Dovanų: " + got.map(function (g) { return g.title; }).join(", ") + "." : "";
    if (nx) {
      var need = (Math.round((nx.kg - kg) * 100) / 100).toString().replace(".", ",");
      a += (a ? " " : "") + "Dar " + need + " kg, ir gausi dovaną: " + nx.title + ".";
    }
    return a;
  }
  function tierHintText() {
    var nx = nextTier();
    if (!nx) return "Taikoma didžiausia nuolaida −" + tierPct() + "%.";
    var kgT = (Math.round(nx.needKg * 100) / 100).toString().replace(".", ",");
    return "Dar " + kgT + " kg, ir nuolaida bus −" + nx.pct + "%.";
  }
  /* „Tavo siunta“: kiekis + nuolaida, juosta iki artimiausio tikslo
     (pakopos ar dovanos), įdėtos dovanos. Viskas vienoje kortelėje. */
  function paintShipbox(n) {
    var q = el.qtyTotal, th = el.tierHint, gh = el.giftHint;
    if (!q) return;
    q.innerHTML = "";
    if (th) th.innerHTML = "";
    if (gh) gh.innerHTML = "";
    if (!n) return;
    var lab = document.createElement("span"); lab.className = "pren-sb-l"; lab.textContent = "Tavo siunta";
    var main = document.createElement("b"); main.textContent = packs(n) + (shipmentGrams() > 0 ? " · " + kgText(shipmentGrams()) : "");
    q.appendChild(lab); q.appendChild(main);
    if (!PLAN_MODE) return;
    var pc = document.createElement("span"); pc.className = "pren-sb-pct"; pc.textContent = "−" + tierPct() + "%";
    q.appendChild(pc);
    var kg = curKg(), nx = nextTier(), ng = null;
    for (var i = 0; i < GIFTS.length; i++) if (kg + 1e-9 < GIFTS[i].kg) { ng = GIFTS[i]; break; }
    var goal = null;
    if (nx) goal = { kg: kg + nx.needKg, t: "nuolaida −" + nx.pct + "%" };
    if (ng && (!goal || ng.kg < goal.kg - 1e-9)) goal = { kg: ng.kg, t: "dovana: " + giftShort(ng) };
    if (th) {
      /* pakopų skalė: 1–4 kg nuolaidos, toliau dovanos; pasiektos — nuspalvintos */
      var stops = TIERS.filter(function (t) { return t.kg > 0; }).map(function (t) { return { kg: t.kg, pct: t.pct }; })
        .concat([{ kg: 1, pct: 25 }]).sort(function (x, y) { return x.kg - y.kg; })
        .filter(function (t, i, arr) { return !i || arr[i - 1].kg !== t.kg; });
      GIFTS.forEach(function (g) { stops.push({ kg: g.kg, gift: g }); });
      var sc = document.createElement("ol"); sc.className = "pren-sb-scale";
      sc.setAttribute("aria-label", "Nuolaidos ir dovanos pagal siuntos kiekį");
      stops.forEach(function (st) {
        var li = document.createElement("li");
        var on = kg + 1e-9 >= st.kg;
        li.className = (on ? "is-on" : "") + (st.gift ? " is-gift" : "") + (goal && Math.abs(goal.kg - st.kg) < 1e-9 ? " is-next" : "");
        var top = document.createElement("span"); top.className = "pren-sb-t";
        if (st.gift && st.gift.img) { var gi = document.createElement("img"); gi.src = st.gift.img; gi.alt = "Dovana: " + st.gift.title; top.appendChild(gi); }
        else top.textContent = st.pct ? "−" + st.pct + "%" : "";
        var dot = document.createElement("span"); dot.className = "pren-sb-d";
        var k = document.createElement("span"); k.className = "pren-sb-k"; k.textContent = st.kg + " kg";
        li.appendChild(top); li.appendChild(dot); li.appendChild(k);
        sc.appendChild(li);
      });
      th.appendChild(sc);
      var txt = document.createElement("span"); txt.className = "pren-sb-next";
      if (goal) {
        txt.innerHTML = "Dar <b>" + kgNum(goal.kg - kg) + " kg</b> – ";
        txt.appendChild(document.createTextNode(goal.t));
      } else {
        txt.textContent = GIFTS.length ? "Pasiekta didžiausia nuolaida ir visos dovanos" : "Taikoma didžiausia nuolaida";
      }
      th.appendChild(txt);
    }
    if (gh) giftsFor(kg).forEach(function (g) {
      var c = document.createElement("span"); c.className = "pren-sb-gift";
      if (g.img) { var im = document.createElement("img"); im.src = g.img; im.alt = ""; c.appendChild(im); }
      var t = document.createElement("span"); t.textContent = "Dovana: " + giftShort(g); c.appendChild(t);
      gh.appendChild(c);
    });
  }
  function planLabel() {
    var i = checkedPlanInput();
    if (i) return i.getAttribute("data-lt") || "";
    return state.freq ? ltLabelFromDays(state.freq) : "";
  }

  /* ---------- busena ---------- */
  var state = {
    format: "beans",
    freq: null,
    planId: 0,
    /* state.format visada turi reiksme (jos reikia duomenu paieskai), o
       fmtChosen pasako, ar zmogus tikrai pasirinko. */
    fmtChosen: false,
    step: 1,
    taste: "all",
    selBy: { beans: [], ground: [] }
  };

  if (PLAN_MODE) {
    localisePlans();
    var pi0 = checkedPlanInput();
    if (pi0) {
      state.planId = parseInt(pi0.value, 10) || 0;
      var d0 = parseInt(pi0.getAttribute("data-days"), 10);
      state.freq = isFinite(d0) ? d0 : null;
    }
  } else {
    var f0 = root.querySelector('input[name="pren-freq"]:checked');
    if (f0) state.freq = parseInt(f0.value, 10) || null;
  }
  if (!Object.keys(BY.beans).length) state.format = "ground";

  function map() { return BY[state.format]; }
  function hasPlans() { return ITEMS.some(function (it) { return it.sp.length; }); }

  function planFor(it) {
    if (!it.sp.length || !PLAN_MODE) return null;
    var days = state.freq, want = tierPct(), best = null;
    /* tas pats dažnis, nuolaida pagal pakopą; jei tokios nėra — artimiausia mažesnė */
    for (var i = 0; i < it.sp.length; i++) {
      var s = it.sp[i];
      if (days && s.days !== days) continue;
      if (s.pct === want) return s;
      if (s.pct < want && (!best || s.pct > best.pct)) best = s;
    }
    if (best) return best;
    for (var k = 0; k < it.sp.length; k++) if (it.sp[k].id === state.planId) return it.sp[k];
    return null;
  }
  function netFor(it) {
    var p = planFor(it);
    return (p && typeof p.pd === "number" && !isNaN(p.pd)) ? p.pd : null;
  }

  /* ---------- pasirinkimas su kiekiais ---------- */
  function selArr() { return state.selBy[state.format]; }
  function findSel(k) {
    var a = selArr();
    for (var i = 0; i < a.length; i++) if (a[i].k === k) return i;
    return -1;
  }
  function countOf(k) { var i = findSel(k); return i < 0 ? 0 : selArr()[i].n; }
  function sumN() {
    var a = selArr(), s = 0;
    for (var i = 0; i < a.length; i++) s += a[i].n;
    return s;
  }

  /* Vienintelis budas keisti kieki. Nieko neismeta: pasiekus riba
     tik pasako, kad daugiau nebegalima. */
  function bump(k, delta) {
    if (!map()[k]) return;
    var a = selArr(), i = findSel(k), cur = i < 0 ? 0 : a[i].n;
    var next = cur + delta;
    if (delta > 0 && sumN() >= maxQ()) {
      say("Daugiau negalima, daugiausia " + packs(maxQ()) + " siuntoje.");
      render();
      return;
    }
    if (next <= 0) {
      if (i > -1) a.splice(i, 1);
      say("Išimta " + map()[k].o + ". Siuntoje " + packs(sumN()) + ".");
    } else {
      if (i < 0) a.push({ k: k, n: next }); else a[i].n = next;
      say((delta > 0 ? "Pridėta " : "Pakeista ") + map()[k].o + ". Siuntoje " + packs(sumN()) + ".");
    }
    render();
  }

  function syncChoices() {
    Array.prototype.forEach.call(root.querySelectorAll(".pren-choice"), function (lab) {
      var i = lab.querySelector("input");
      lab.classList.toggle("is-on", !!(i && i.checked));
    });
  }

  function formatGrams() {
    var dflt = state.format === "beans" ? 1000 : 250;
    var keys = ORDER[state.format];
    for (var i = 0; i < keys.length; i++) {
      var g = BY[state.format][keys[i]].g;
      if (g > 0) return g;
    }
    return dflt;
  }
  function shipmentGrams() {
    var a = selArr(), g = 0;
    for (var i = 0; i < a.length; i++) {
      var it = map()[a[i].k];
      g += (it.g > 0 ? it.g : formatGrams()) * a[i].n;
    }
    return g;
  }

  /* ---------- kaina ---------- */
  function lines() {
    var out = [];
    selArr().forEach(function (r) { if (map()[r.k]) out.push({ it: map()[r.k], n: r.n }); });
    return out;
  }
  function priceModel() {
    var L = lines(), base = 0, net = 0, missing = [];
    L.forEach(function (r) {
      base += r.it.p * r.n;
      var pd = netFor(r.it);
      if (pd === null) missing.push(r.it.o); else net += pd * r.n;
    });
    var ok = L.length > 0 && !missing.length;
    return { lines: L, base: base, net: ok ? net : null, missing: missing };
  }

  /* ---------- modalas ---------- */
  var modal = root.querySelector("[data-pren-modal]");
  var mEl = {};
  ["modalImg", "modalTitle", "modalPrice", "modalNote", "modalText", "modalAdd",
    "modalLink", "modalClose", "modalBack", "modalTags"].forEach(function (k) {
      mEl[k] = root.querySelector("[data-pren-" + k + "]");
    });
  var modalKey = null, lastFocus = null;

  function openModal(k) {
    var it = map()[k] || BY.beans[k] || BY.ground[k];
    if (!it || !modal) return;
    modalKey = k;
    lastFocus = document.activeElement;
    if (mEl.modalImg) { mEl.modalImg.src = it.big || it.img; mEl.modalImg.alt = it.o; }
    if (mEl.modalTitle) mEl.modalTitle.textContent = it.o;
    if (mEl.modalPrice) {
      /* Rodom prenumeratos kaina su perbraukta pilna — taip pat, kaip visur
         kitur puslapyje. Jei planas neprieinamas, rodom tik pilna kaina. */
      mEl.modalPrice.innerHTML = "";
      var pdM = netFor(it);
      if (pdM !== null && pdM < it.p) {
        var sM = document.createElement("s");
        sM.textContent = money(it.p);
        var bM = document.createElement("b");
        bM.textContent = money(pdM);
        var uM = document.createElement("span");
        uM.textContent = "su prenumerata · " + (it.f === "beans" ? "1 kg pupelių" : "250 g maltos");
        mEl.modalPrice.appendChild(sM);
        mEl.modalPrice.appendChild(bM);
        mEl.modalPrice.appendChild(uM);
        /* didžiausios pakopos kaina — kad matytųsi, kiek pigiau imant daugiau */
        var top = null;
        it.sp.forEach(function (p) { if ((!state.freq || p.days === state.freq) && (!top || p.pct > top.pct)) top = p; });
        if (top && top.pd < pdM) {
          var tM = document.createElement("em");
          tM.className = "pren-modal-tier";
          tM.textContent = "Perkant nuo 4 kg: " + money(top.pd) + " (−" + top.pct + "%)";
          mEl.modalPrice.appendChild(tM);
        }
      } else {
        var bM2 = document.createElement("b");
        bM2.textContent = money(it.p);
        var uM2 = document.createElement("span");
        uM2.textContent = it.f === "beans" ? "1 kg pupelių" : "250 g maltos";
        mEl.modalPrice.appendChild(bM2);
        mEl.modalPrice.appendChild(uM2);
      }
    }
    if (mEl.modalTags) {
      mEl.modalTags.innerHTML = "";
      it.taste.forEach(function (t) {
        if (!TASTE_LT[t]) return;
        var s = document.createElement("span");
        s.textContent = TASTE_LT[t];
        mEl.modalTags.appendChild(s);
      });
      mEl.modalTags.hidden = !mEl.modalTags.firstChild;
    }
    if (mEl.modalNote) { mEl.modalNote.textContent = it.note || ""; mEl.modalNote.hidden = !it.note; }
    if (mEl.modalText) fillModalText(mEl.modalText, it);
    /* trumpas ištraukas kartoja aprašymo pirmą eilutę — nerodom */
    if (mEl.modalNote) mEl.modalNote.hidden = true;
    if (mEl.modalLink) mEl.modalLink.href = it.url || "#";
    syncModalAdd();
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    if (mEl.modalClose) mEl.modalClose.focus();
  }
  /* Aprašymas iš produkto: skonio eilutė, pastraipos ir „Etiketė: reikšmė. …“
     sąrašas. Sąrašą paverčiam savybių lentele, pastraipas sutraukiam,
     prenumeratos reklamos sakinį išmetam (kaina jau rodoma viršuje). */
  function fillModalText(box, it) {
    box.innerHTML = "";
    if (!it.fullEl) return;
    var src = it.fullEl.cloneNode(true);
    Array.prototype.forEach.call(src.querySelectorAll("img, script, style"), function (n) { n.remove(); });
    var facts = [], paras = [], taste = null;
    Array.prototype.forEach.call(src.querySelectorAll("li"), function (li) {
      var t = li.textContent.replace(/\s+/g, " ").trim();
      var m = t.match(/^([^:]{2,40}):\s*(.+)$/);
      if (m) {
        var v = m[2].split(/\.\s/)[0].replace(/\.$/, "");
        facts.push([m[1].trim(), v]);
      } else if (t && !/^Prenumeratoje/i.test(t)) paras.push(t);
    });
    Array.prototype.forEach.call(src.querySelectorAll("p"), function (p) {
      var t = p.textContent.replace(/\s+/g, " ").trim();
      if (!t || /^Prenumeratoje/i.test(t)) return;
      if (!taste && p.querySelector("b, strong") && t.indexOf("·") > -1 && t.length < 160) { taste = p; return; }
      paras.push(t);
    });
    if (taste) {
      var tl = document.createElement("p");
      tl.className = "pren-mt-taste";
      tl.innerHTML = taste.innerHTML;
      box.appendChild(tl);
    }
    if (facts.length) {
      var dl = document.createElement("dl");
      dl.className = "pren-mt-facts";
      facts.slice(0, 8).forEach(function (f) {
        if (/^Pakuotė/i.test(f[0])) return;
        var w = document.createElement("div");
        var dt = document.createElement("dt"); dt.textContent = f[0];
        var dd = document.createElement("dd"); dd.textContent = f[1];
        w.appendChild(dt); w.appendChild(dd); dl.appendChild(w);
      });
      box.appendChild(dl);
    }
    if (paras.length) {
      var d = document.createElement("div");
      d.className = "pren-mt-desc is-clamped";
      paras.forEach(function (t) { var p = document.createElement("p"); p.textContent = t; d.appendChild(p); });
      box.appendChild(d);
      var more = document.createElement("button");
      more.type = "button"; more.className = "pren-mt-more"; more.textContent = "Skaityti daugiau";
      more.addEventListener("click", function () {
        var open = d.classList.toggle("is-clamped");
        more.textContent = open ? "Skaityti daugiau" : "Rodyti mažiau";
      });
      box.appendChild(more);
      /* trumpam tekstui mygtuko nereikia */
      requestAnimationFrame(function () { if (d.scrollHeight <= d.clientHeight + 4) { d.classList.remove("is-clamped"); more.remove(); } });
    }
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modalKey = null;
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function syncModalAdd() {
    if (!mEl.modalAdd || !modalKey) return;
    var inCurrent = !!map()[modalKey];
    var n = countOf(modalKey);
    mEl.modalAdd.disabled = !inCurrent;
    mEl.modalAdd.textContent = !inCurrent
      ? (state.format === "ground" ? "Maltos nėra" : "Nėra")
      : (n > 0 ? "Pridėti dar (" + n + ")" : "Įtraukti");
  }
  if (mEl.modalAdd) mEl.modalAdd.addEventListener("click", function () {
    if (!modalKey) return;
    bump(modalKey, 1);
    syncModalAdd();
  });
  if (mEl.modalClose) mEl.modalClose.addEventListener("click", closeModal);
  if (mEl.modalBack) mEl.modalBack.addEventListener("click", closeModal);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal && !modal.hidden) closeModal();
  });

  /* ---------- korteliu prijungimas ---------- */
  ITEMS.forEach(function (it) {
    if (it.pick) it.pick.addEventListener("click", function () {
      if (it.pick.disabled) return;
      bump(it.k, 1);
    });
    var info = it.el.querySelector("[data-pren-more]");
    if (info) info.addEventListener("click", function () { openModal(it.k); });
    var minus = it.el.querySelector("[data-cq-minus]");
    var plus = it.el.querySelector("[data-cq-plus]");
    if (minus) minus.addEventListener("click", function (e) { e.stopPropagation(); bump(it.k, -1); });
    if (plus) plus.addEventListener("click", function (e) { e.stopPropagation(); bump(it.k, 1); });
  });

  /* ---------- skonio filtrai ---------- */
  function setTaste(t) {
    state.taste = t || "all";
    Array.prototype.forEach.call(root.querySelectorAll(".pren-filter"), function (o) {
      var on = (o.getAttribute("data-taste") || "all") === state.taste;
      o.classList.toggle("is-on", on);
      o.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll(".pren-filter"), function (b) {
    b.addEventListener("click", function () {
      setTaste(b.getAttribute("data-taste"));
      render();
    });
  });

  /* ---------- skaiciuotuvas ---------- */
  var pickedCups = 0;

  function freqOptions() {
    var out = [];
    var plns = root.querySelectorAll('input[name="pren-plan"]');
    if (plns.length) {
      Array.prototype.forEach.call(plns, function (i) {
        var d = parseInt(i.getAttribute("data-days"), 10);
        if (isFinite(d) && d > 0) out.push({ days: d, input: i });
      });
    } else {
      Array.prototype.forEach.call(root.querySelectorAll('input[name="pren-freq"]'), function (i) {
        out.push({ days: parseInt(i.value, 10) || 30, input: i });
      });
    }
    out.sort(function (a, b) { return a.days - b.days; });
    return out;
  }

  function suggest(cups) {
    var need = cups * GRAMS_PER_CUP * DAYS_PER_MONTH;
    var pg = formatGrams();
    var best = null;
    freqOptions().forEach(function (o) {
      var perShip = need * (o.days / DAYS_PER_MONTH);
      var q = Math.max(1, Math.min(maxQ(), Math.round(perShip / pg)));
      var delivered = q * pg * (DAYS_PER_MONTH / o.days);
      var stockDays = (q * pg) / (need / DAYS_PER_MONTH);
      var fresh = stockDays <= 42;
      var err = Math.abs(delivered - need);
      var cand = { days: o.days, qty: q, delivered: delivered, err: err, fresh: fresh, input: o.input };
      if (!best) { best = cand; return; }
      if (best.fresh !== cand.fresh) { if (cand.fresh) best = cand; return; }
      if (cand.err < best.err - Math.max(20, need * 0.05)) best = cand;
    });
    return { need: need, best: best };
  }

  /* Rekomendacija tekstu + mygtukas. Mygtukas rodomas TIK kai yra ka pritaikyti:
     yra pasiulymas, yra bent viena pasirinkta kava ir dabartinis kiekis nesutampa. */
  function renderCalc() {
    if (!el.calcOut) return;
    if (!pickedCups) {
      el.calcOut.textContent = "";
      if (el.calcApply) el.calcApply.hidden = true;
      return;
    }
    var s = suggest(pickedCups);
    if (!s.best) {
      el.calcOut.textContent = "";
      if (el.calcApply) el.calcApply.hidden = true;
      return;
    }
    var lab = ltLabelFromDays(s.best.days).toLowerCase();
    var txt = "Tau reikia apie " + kgText(s.need) + " per mėnesį. Tiek išeina " +
      packs(s.best.qty) + " " + lab + " — " + kgText(s.best.delivered) + " per mėnesį." +
      " Dažnumą jau nustatėme, kiekį pasirenki pats.";
    var picked = selArr().length;
    var now = sumN();
    if (!picked) txt += " Pasirink kavas žemiau, o tada šį kiekį pritaikysi vienu paspaudimu.";
    el.calcOut.textContent = txt;
    if (el.calcApply) {
      var show = picked > 0 && now !== s.best.qty;
      el.calcApply.hidden = !show;
      if (show) {
        el.calcApply.textContent = "Pritaikyti: " + packs(s.best.qty);
        el.calcApply.setAttribute("aria-label",
          "Pritaikyti rekomenduojamą kiekį: " + packs(s.best.qty) + ", paskirstant tarp pasirinktų kavų");
      }
    }
  }

  /* Paskirsto rekomenduojama kieki tarp JAU pasirinktu kavu (paeiliai po vieną),
     naujos kavos nededa ir nei vienos neismeta. */
  function applyRecommendedQty() {
    if (!pickedCups) return;
    var s = suggest(pickedCups);
    if (!s.best) return;
    var a = selArr();
    if (!a.length) { say("Pirma pasirink bent vieną kavą."); return; }
    var total = Math.max(a.length, Math.min(maxQ(), s.best.qty));
    var base = Math.floor(total / a.length);
    var rest = total - base * a.length;
    a.forEach(function (row, i) { row.n = base + (i < rest ? 1 : 0); });
    say("Pritaikyta: " + packs(sumN()) + ", paskirstyta tarp " + kinds(a.length) + ".");
    renderCalc();
    render();
  }
  if (el.calcApply) el.calcApply.addEventListener("click", applyRecommendedQty);

  /* Nustato TIK daznuma. Kiekio ir kavu nekeicia — tai lieka zmogui. */
  function applyCups(cups) {
    pickedCups = cups;
    dailyCups = cups;
    markQuiz("cups", String(cups));
    if (el.calcOpts) {
      Array.prototype.forEach.call(el.calcOpts.querySelectorAll(".pren-calc-opt"), function (b) {
        var on = parseInt(b.getAttribute("data-cups"), 10) === cups;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    var s = suggest(cups);
    if (s.best) {
      if (s.best.input) {
        s.best.input.checked = true;
        if (s.best.input.name === "pren-plan") {
          state.planId = parseInt(s.best.input.value, 10) || 0;
          var dd = parseInt(s.best.input.getAttribute("data-days"), 10);
          state.freq = isFinite(dd) ? dd : null;
        } else {
          state.freq = parseInt(s.best.input.value, 10) || null;
        }
      }
      say("Siūlome " + packs(s.best.qty) + " " + ltLabelFromDays(s.best.days).toLowerCase() + ".");
    }
    syncChoices();
    renderCalc();
    render();
  }
  if (el.calcOpts) {
    Array.prototype.forEach.call(el.calcOpts.querySelectorAll(".pren-calc-opt"), function (b) {
      b.addEventListener("click", function () {
        applyCups(parseInt(b.getAttribute("data-cups"), 10) || 2);
      });
    });
  }

  /* ==================== GREITAS PASIRINKIMAS ====================
     Kavos parinkimas (3 klausimai po viena) ir paruosti rinkiniai. Abu tik
     UZPILDO sarasa — kiekviena pritaikyma galima atsaukti, o toliau zmogus
     keicia ranka. Kavos parenkamos is tu paciu skonio zymiu, kurias naudoja
     filtrai.
     IVAIROVE: kavos traukiamos atsitiktinai, svoris = tinkamumo balas
     kvadratu — geriausiai tinkancios iskrenta dazniau, bet ne visada tos
     pacios. "seen" saugo jau rodytas, todel "Rodyti kitas" nekartoja, kol
     tinkamu kavu dar yra. */
  var dailyCups = 0;          /* paskutinis zinomas puodeliu skaicius is bet kurios vietos */
  var undoSel = null;
  var setsFmt = null;
  var TASTE_ORDER = ["chocolate", "fruit", "caramel", "nut"];
  var MILKY = ["chocolate", "nut", "caramel"];

  function inFormat() {
    return ORDER[state.format].map(function (k) { return BY[state.format][k]; });
  }
  function withTaste(t) {
    return inFormat().filter(function (it) { return it.taste.indexOf(t) > -1; });
  }
  /* Kiek pakuociu reikia vienai siuntai prie dabartinio daznumo. */
  function qtyForCups(cups) {
    var days = state.freq || 30;
    var need = cups * GRAMS_PER_CUP * days;
    var q = Math.round(need / formatGrams());
    /* ta pati riba kaip patarime: jei uztektu maziau nei 85 % laiko — viena daugiau */
    if (q * formatGrams() < need * 0.85) q++;
    return Math.max(1, Math.min(maxQ(), q));
  }
  function defaultTotal() {
    /* be zinomo puodeliu skaiciaus imamas vidutinis namu vartojimas (3–4) */
    return sumN() || qtyForCups(dailyCups || 4);
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  function asPool(its) { return its.map(function (it) { return { it: it, w: 1 }; }); }

  /* Svertinis atsitiktinis traukimas be pasikartojimu (Efraimidis–Spirakis). */
  function draw(pool, n, seen) {
    var fresh = pool.filter(function (x) { return !seen[x.it.k]; });
    if (fresh.length < n) {
      for (var k in seen) if (Object.prototype.hasOwnProperty.call(seen, k)) delete seen[k];
      fresh = pool.slice();
    }
    fresh.forEach(function (x) { x.r = Math.pow(Math.random(), 1 / Math.max(0.01, x.w)); });
    fresh.sort(function (a, b) { return b.r - a.r; });
    var out = fresh.slice(0, n).map(function (x) { return x.it; });
    out.forEach(function (it) { seen[it.k] = true; });
    return out;
  }
  /* Po viena is skirtingu skoniu, skoniu tvarka atsitiktine. */
  function pickVaried(n, seen, skip) {
    var out = [], used = {};
    (skip || []).forEach(function (k) { used[k] = true; });
    shuffle(TASTE_ORDER.slice()).forEach(function (t) {
      if (out.length >= n) return;
      var got = draw(asPool(withTaste(t).filter(function (x) { return !used[x.k]; })), 1, seen)[0];
      if (got) { out.push(got); used[got.k] = true; }
    });
    if (out.length < n) {
      draw(asPool(inFormat().filter(function (x) { return !used[x.k]; })), n - out.length, seen)
        .forEach(function (x) { out.push(x); });
    }
    return out;
  }
  /* Bendras kiekis paskirstomas po lygiai, pradedant nuo pirmos kavos. */
  function spread(its, total) {
    total = Math.max(1, Math.min(maxQ(), total));
    its = its.slice(0, total);
    if (!its.length) return [];
    var base = Math.floor(total / its.length), rest = total - base * its.length;
    return its.map(function (it, i) { return { k: it.k, n: base + (i < rest ? 1 : 0) }; });
  }
  function applyRows(rows, label, quiet) {
    if (!rows.length) { say("Šiam pasirinkimui tinkamų kavų nėra."); return; }
    undoSel = { fmt: state.format, rows: selArr().map(function (r) { return { k: r.k, n: r.n }; }) };
    state.selBy[state.format] = rows;
    setTaste("all");
    var names = rows.map(function (r) { return BY[state.format][r.k].o + (r.n > 1 ? " ×" + r.n : ""); });
    if (el.setOut) {
      el.setOut.innerHTML = "";
      var lb = document.createElement("b"); lb.textContent = "Į siuntą įdėta: ";
      el.setOut.appendChild(lb);
      el.setOut.appendChild(document.createTextNode(names.join(", ") + ". Kiekius gali keisti sąraše žemiau."));
    }
    if (el.done) el.done.hidden = false;
    say(label + ": " + packs(sumN()) + ", " + kinds(rows.length) + ".");
    setMode("self", true);
    renderCalc();
    render();
    if (el.done && el.done.scrollIntoView) {
      el.done.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    }
  }

  /* --- kaip renkiesi: padėkite / rinkinys / pats ---
     Rodomas tik pasirinktas būdas; sąrašas — tik "Renkuosi pats" režime
     (į jį automatiškai pereinama pritaikius klausimyną ar rinkinį). */
  var MODE = "help";
  function setMode(m, silent) {
    MODE = m;
    if (el.modes) Array.prototype.forEach.call(el.modes.querySelectorAll("[data-mode]"), function (b) {
      var on = b.getAttribute("data-mode") === m;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    Array.prototype.forEach.call(root.querySelectorAll("[data-panel]"), function (pn) { pn.hidden = pn.getAttribute("data-panel") !== m; });
    if (el.picker) el.picker.hidden = m !== "self";
    if (!silent) say(m === "help" ? "Atsakyk į 5 trumpus klausimus." : (m === "sets" ? "Pasirink rinkinį." : "Rinkis kavas sąraše."));
  }
  if (el.modes) Array.prototype.forEach.call(el.modes.querySelectorAll("[data-mode]"), function (b) {
    b.addEventListener("click", function () { setMode(b.getAttribute("data-mode")); });
  });
  if (el.undo) el.undo.addEventListener("click", function () {
    if (!undoSel) return;
    state.selBy[undoSel.fmt] = undoSel.rows;
    undoSel = null;
    if (el.done) el.done.hidden = true;
    if (el.setOut) el.setOut.textContent = "";
    if (FD.done) { FD.done = false; renderFinder(false); }
    say("Grąžintas ankstesnis pasirinkimas.");
    renderCalc();
    render();
  });

  var SETS = [
    /* pazintinis visada trys skirtingos rusys — tam jis ir skirtas */
    { id: "varied", label: "Pažintinis", desc: "3 skirtingi skoniai, gera pradžia", min: 3, seen: {}, run: function () { return pickVaried(3, this.seen); } },
    { id: "chocolate", label: "Šokoladinis", desc: "Sodrios šokolado ir riešutų natos", taste: "chocolate", seen: {} },
    { id: "fruit", label: "Vaisinis", desc: "Gaivesnės vaisių ir uogų natos", taste: "fruit", seen: {} },
    { id: "caramel", label: "Karamelinis", desc: "Saldesnės karamelės ir medaus natos", taste: "caramel", seen: {} }
  ];
  /* Rinkiniai perpiesiami tik pasikeitus formatui: perpiesiant kiekviena
     karta mygtukas prarastu fokusa. Skonio rinkinys rodomas tik tada, kai
     tokiu kavu sitame formate yra bent dvi. Pakartotinis paspaudimas duoda
     kita to paties skonio rinkini. */
  function buildSets() {
    if (!el.setOpts || setsFmt === state.format) return;
    setsFmt = state.format;
    el.setOpts.innerHTML = "";
    SETS.forEach(function (s) {
      s.seen = {};
      if (s.taste && withTaste(s.taste).length < 2) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pren-set-tile";
      var bt = document.createElement("b"); bt.textContent = s.label;
      var bd = document.createElement("small"); bd.textContent = s.desc;
      b.appendChild(bt); b.appendChild(bd);
      b.addEventListener("click", function () {
        var n = Math.min(maxQ(), Math.max(s.min || 1, defaultTotal()));
        var its = s.run ? s.run() : draw(asPool(withTaste(s.taste)), Math.min(n, 3), s.seen);
        applyRows(spread(its, n), s.label + " rinkinys");
      });
      el.setOpts.appendChild(b);
    });
    el.setOpts.hidden = !el.setOpts.firstChild;
  }

  /* --- kavos parinkimas: mini klausimynas (5 klausimai) ---
     Paruosimo budas, pienas, skoniai (iki 2), stiprumas, puodeliai. Kiekvienas
     atsakymas prideda balu kavoms; rezultatas — geriausiai tinkancios su
     priezastimis, "Kita" prie kiekvienos ir "Rodyti kitas". Nieko neidedama,
     kol nepaspausta "Įdėti". Stiprumas ir misinys — apytiksliai is aprasymo,
     todel jie tik prideda svorio, o ne atmeta kavas (isskyrus be kofeino). */
  var QS = [
    { key: "brew", h: "Kuo dažniausiai ruoši kavą?", opts: [
      ["espresso", "Espreso aparatu", "Rankiniu, su svirtimi ar nešiojamu"],
      ["auto", "Automatiniu aparatu", "Pats mala pupeles", "beans"],
      ["moka", "Kavinuku ant viryklės", "Moka kavinukas"],
      ["filter", "Filtru ar presu", "Pour-over, filtro aparatas, French press"]] },
    { key: "milk", h: "Kaip dažniausiai geri kavą?", opts: [
      ["black", "Juodą", "Espresas, filtras, americano"],
      ["milk", "Su pienu", "Kapučinas, latte, flat white"],
      ["both", "Būna visaip", "Priklauso nuo dienos"]] },
    { key: "taste", multi: 2, h: "Kokie skoniai traukia labiausiai?", sub: "Gali pažymėti iki dviejų.", opts: [
      ["chocolate nut", "Šokoladas ir riešutai", "Sodrus, apvalus skonis"],
      ["fruit", "Vaisiai ir uogos", "Gaivesnis, ryškesnis"],
      ["caramel", "Karamelė ir medus", "Saldesnis, švelnesnis"],
      ["mix", "Noriu įvairių", "Po vieną iš skirtingų skonių"]] },
    { key: "str", h: "Kokio stiprumo kavą mėgsti?", opts: [
      ["mild", "Švelnią", "Lengva, be kartumo"],
      ["mid", "Subalansuotą", "Nei per švelni, nei per stipri"],
      ["strong", "Sodrią, stiprią", "Intensyvi, su lengvu kartumu"],
      ["decaf", "Be kofeino", "Vakarui ar jautresniems"]] },
    { key: "cups", h: "Kiek puodelių per dieną išgeri namuose?", opts: [
      ["2", "1–2", ""], ["4", "3–4", ""], ["6", "5–6", ""], ["9", "7 ir daugiau", ""]] }
  ];
  var FD = { step: 1, a: { brew: "", milk: "", taste: "", str: "", cups: 0 }, tsel: [], res: [], seen: {}, done: false, fmt: null, qty: 0 };

  /* advice ir senas skaiciuotuvas praneša apie puodelius per sita funkcija */
  function markQuiz(q, v) { if (q === "cups" && !FD.a.cups) FD.a.cups = parseInt(v, 10) || 0; }

  function mk(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function mkBtn(cls, txt, fn) {
    var b = mk("button", cls, txt);
    b.type = "button";
    b.addEventListener("click", fn);
    return b;
  }
  function qOpts(Q) {
    return Q.opts.filter(function (o) { return !o[3] || o[3] === state.format; });
  }
  function has(it, t) { return it.taste.indexOf(t) > -1; }
  function hasAny(it, ts) { return it.taste.some(function (t) { return ts.indexOf(t) > -1; }); }
  function wantTastes(a) { return a.taste === "mix" ? [] : a.taste.split(" ").filter(Boolean); }

  /* Balai uz kiekviena atsakyma; why — trumpos priezastys rezultatui. */
  function scoreOf(it, a) {
    var s = 0, why = [];
    var want = wantTastes(a);
    var hit = it.taste.filter(function (t) { return want.indexOf(t) > -1; });
    if (hit.length) {
      s += 3 + (hit.length - 1);
      why.push(hit.slice(0, 2).map(function (t) { return TASTE_LT[t].toLowerCase(); }).join(", "));
    }
    var dark = it.blend || hasAny(it, MILKY);
    if (a.brew === "filter") {
      if (has(it, "fruit") && !it.blend) { s += 2; why.push("atsiskleidžia filtre"); }
      else if (it.blend) s -= 2;
      if (it.str === "mild") s += 1;
    } else if (a.brew) {
      if (it.blend) { s += 2; why.push(a.brew === "moka" ? "tinka kavinukui" : "sukurta espresui"); }
      else if (hasAny(it, MILKY)) { s += 1; why.push(a.brew === "moka" ? "tinka kavinukui" : "tinka espresui"); }
    }
    if (a.milk === "milk" && dark) { s += 1; why.push("gerai dera su pienu"); }
    else if (a.milk === "black" && has(it, "fruit")) { s += 1; why.push("geriausia juoda"); }
    if (a.str === "decaf") {
      if (it.decaf) { s += 10; why.unshift("be kofeino"); } else s -= 10;
    } else {
      if (it.decaf) s -= 10;
      if (a.str === "strong") {
        if (it.str === "strong" || it.blend) { s += 2; why.push("sodri ir stipri"); }
        else if (it.str === "mild") s -= 1;
      } else if (a.str === "mild") {
        if (it.str === "mild") { s += 2; why.push("švelni"); }
        else if (it.str === "strong" || it.blend) s -= 1;
        else if (has(it, "caramel")) s += 1;
      } else if (a.str === "mid") {
        if (!it.str && !it.blend) { s += 1; why.push("subalansuota"); }
        else if (it.str === "strong") s -= 1;
      }
    }
    /* pirkeju labai vertinamos kavos — nedidelis prioritetas */
    if (it.rn >= 5 && it.ra >= 4.8) s += 1;
    return { s: s, why: why };
  }
  /* Tinkamos kavos: ne toliau nei 3 balai nuo geriausios. Svoris kvadratu —
     geriausios iskrenta dazniau, bet ne visada tos pacios. */
  function scoredPool(a) {
    var all = inFormat().map(function (it) { return { it: it, s: scoreOf(it, a).s }; });
    var best = all.reduce(function (m, x) { return Math.max(m, x.s); }, -99);
    var floor = Math.max(1, best - 3);
    return all.filter(function (x) { return x.s >= floor; })
      .map(function (x) { x.w = Math.pow(x.s - floor + 1, 2); return x; });
  }
  function resultSize() {
    var total = FD.qty || qtyForCups(FD.a.cups || 4);
    return { total: total, n: Math.min(total, 3) };
  }
  /* rezultato kiekio parinktys: kiek reikia pagal puodelius + 2 kg ir 4 kg pakopos */
  function qtyChoices() {
    var per = 1000 / formatGrams(), need = qtyForCups(FD.a.cups || 4), out = [];
    [need, Math.round(2 * per), Math.round(4 * per)].forEach(function (q) {
      q = Math.max(1, Math.min(maxQ(), q));
      if (out.indexOf(q) < 0) out.push(q);
    });
    return { need: need, list: out.sort(function (a, b) { return a - b; }) };
  }
  function pctForQty(q) { return tierFor(q * formatGrams() / 1000).pct; }
  /* kaina už pakuotę pasirinktos pakopos plane (ne pagal dabartinį sąrašą) */
  function priceAt(it, pct) {
    if (PLAN_MODE) for (var i = 0; i < it.sp.length; i++) {
      var p = it.sp[i];
      if ((!state.freq || p.days === state.freq) && p.pct === pct && isFinite(p.pd)) return p.pd;
    }
    return priceOf(it);
  }
  function byScore(list) {
    return list.map(function (it) { return { it: it, s: scoreOf(it, FD.a).s }; })
      .sort(function (x, y) { return y.s - x.s; }).map(function (x) { return x.it; });
  }
  function makeResult() {
    var z = resultSize();
    FD.fmt = state.format;
    FD.done = false;
    var pool = scoredPool(FD.a);
    if (FD.a.taste === "mix" && FD.a.str !== "decaf") {
      /* ivairus skoniai, bet is tinkamu pagal kitus atsakymus */
      var out = [], used = {};
      shuffle(TASTE_ORDER.slice()).forEach(function (t) {
        if (out.length >= z.n) return;
        var got = draw(pool.filter(function (x) { return has(x.it, t) && !used[x.it.k]; }), 1, FD.seen)[0];
        if (got) { out.push(got); used[got.k] = true; }
      });
      if (out.length < z.n) draw(pool.filter(function (x) { return !used[x.it.k]; }), z.n - out.length, FD.seen)
        .forEach(function (it) { out.push(it); });
      FD.res = out;
    } else {
      FD.res = draw(pool, z.n, FD.seen);
    }
    if (FD.res.length < z.n && FD.a.str !== "decaf") {
      pickVaried(z.n - FD.res.length, FD.seen, FD.res.map(function (it) { return it.k; }))
        .filter(function (it) { return !it.decaf; })
        .forEach(function (it) { FD.res.push(it); });
    }
    FD.res = byScore(FD.res);
    FD.keep = FD.res.slice();
  }
  /* Keičiant kiekį (1 → 2 → 4 kg) jau parinktos kavos lieka: didinant prie jų
     pridedamos naujos (pirmiausia kito skonio), mažinant – lieka pirmosios.
     Kitaip kiekvienas paspaudimas išmesdavo vis kitas kavas ir atrodė atsitiktinai. */
  function resizeResult() {
    var z = resultSize();
    if (!FD.res || !FD.res.length || FD.fmt !== state.format) { makeResult(); return; }
    /* FD.keep – visas jau parinktų sąrašas: sumažinus ir vėl padidinus kiekį grįžta tos pačios kavos */
    var keep = FD.keep && FD.keep.length ? FD.keep : FD.res.slice();
    FD.res.forEach(function (it, i) { keep[i] = it; });
    FD.keep = keep;
    if (keep.length >= z.n) { FD.res = keep.slice(0, z.n); return; }
    FD.res = keep.slice();
    var cur = {}, tastes = {};
    FD.res.forEach(function (it) { cur[it.k] = true; it.taste.forEach(function (t) { tastes[t] = true; }); });
    var pool = scoredPool(FD.a).filter(function (x) { return !cur[x.it.k]; });
    while (FD.res.length < z.n && pool.length) {
      var fresh = pool.filter(function (x) { return !x.it.taste.some(function (t) { return tastes[t]; }); });
      var got = draw(fresh.length ? fresh : pool, 1, FD.seen)[0];
      if (!got) break;
      FD.res.push(got);
      got.taste.forEach(function (t) { tastes[t] = true; });
      pool = pool.filter(function (x) { return x.it.k !== got.k; });
    }
    if (FD.res.length < z.n && FD.a.str !== "decaf") {
      pickVaried(z.n - FD.res.length, FD.seen, FD.res.map(function (it) { return it.k; }))
        .filter(function (it) { return !it.decaf; })
        .forEach(function (it) { FD.res.push(it); });
    }
    FD.keep = FD.res.slice();
  }
  function swapOne(i) {
    var cur = {};
    FD.res.forEach(function (it) { cur[it.k] = true; });
    var got = draw(scoredPool(FD.a).filter(function (x) { return !cur[x.it.k]; }), 1, FD.seen)[0];
    if (!got) { say("Kitų tinkamų kavų nebėra."); return; }
    FD.res[i] = got;
    if (FD.keep) FD.keep[i] = got;
    FD.done = false;
    say("Pakeista į " + got.o + ".");
    renderFinder(false);
  }
  function whyFor(it) {
    var w = scoreOf(it, FD.a).why;
    if (!w.length) {
      w = it.taste.map(function (x) { return TASTE_LT[x]; }).filter(Boolean)
        .map(function (s) { return s.toLowerCase(); }).slice(0, 2);
      if (w.length) w = [w.join(", ")];
    }
    var s = w.slice(0, 3).join(" · ");
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
  }
  /* --- atsakymu vaizdai: kiekvienas kazka pasako, ne dekoracija ---
     milk  — tos pacios linijos piktogramos kaip formato pasirinkime;
     brew  — paruosimo priemone;
     taste — TIKROS sio formato pakuotes su tuo skoniu ir ju skaicius
             (zmogus mato, is ko bus renkama — tuscio skonio nepasirinks);
     str   — stiprumo skale;
     cups  — puodeliu eile ir apytikslis kiekis per menesi. */
  var CUP = '<path d="M6 10.5h13v5.5a6 6 0 0 1-6 6h-1a6 6 0 0 1-6-6z"></path>' +
    '<path d="M19 12.5h1.4a2.4 2.4 0 0 1 0 4.8H19"></path><path d="M3.5 24.5h18"></path>';
  var ICONS = {
    black: CUP + '<path d="M6.6 12.2h11.8v1.9H6.6z" fill="currentColor" stroke="none"></path>' +
      '<path d="M10 4.5c-.8 1.2.8 2 0 3.2M14 4.5c-.8 1.2.8 2 0 3.2"></path>',
    milk: CUP + '<path d="M8.3 14c1.4-1.3 2.9-1.3 4.2 0s2.9 1.3 4.2 0"></path>' +
      '<path d="M12.5 15.4c-1-.9-2.2-.2-1.6.9l1.6 1.5 1.6-1.5c.6-1.1-.6-1.8-1.6-.9z" fill="currentColor" stroke="none"></path>',
    both: '<g transform="translate(-1.5 2) scale(.72)">' + CUP + '<path d="M6.6 12.2h11.8v1.9H6.6z" fill="currentColor" stroke="none"></path></g>' +
      '<g transform="translate(10.5 2) scale(.72)">' + CUP + '<path d="M8.3 14c1.4-1.3 2.9-1.3 4.2 0s2.9 1.3 4.2 0"></path></g>',
    /* espreso aparatas: korpusas, grupe su rankena, puodelis */
    espresso: '<path d="M5 4.5h18v5H5z"></path><path d="M7 9.5v15M21 9.5v15M5 24.5h18"></path>' +
      '<path d="M10.5 9.5v2.5h7V9.5M17.5 11h3"></path><path d="M11.5 17.5h5v2.5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z"></path>' +
      '<path d="M14 13v2.5"></path>',
    /* automatinis: aukstas korpusas, ekranas, piltuvelis */
    auto: '<rect x="6" y="3.5" width="16" height="21" rx="2"></rect><path d="M9.5 7h9v3.5h-9z"></path>' +
      '<path d="M11 14h6M14 14v2.5"></path><path d="M11.5 18.5h5v2a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z"></path>',
    /* moka kavinukas */
    moka: '<path d="M9 3.5h10l-1.5 9h-7z"></path><path d="M10.5 12.5h7l2 11h-11z"></path>' +
      '<path d="M18.5 5.5h2.5l-1 4M14 3.5V2.5"></path><path d="M6.5 24.5h15"></path>',
    /* filtro piltuvelis ant puodelio */
    filter: '<path d="M6.5 6.5h15l-5 8h-5z"></path><path d="M11 14.5h6M14 3v2"></path>' +
      '<path d="M8 17.5h12v1.5a5 5 0 0 1-5 5h-2a5 5 0 0 1-5-5z"></path>',
    decaf: CUP + '<path d="M8.5 13.5l8 6M16.5 13.5l-8 6"></path>'
  };
  var STR_N = { mild: 1, mid: 2, strong: 3 };
  function svgIcon(body, size) {
    var s = mk("span", "pren-fd-ico");
    s.setAttribute("aria-hidden", "true");
    s.innerHTML = '<svg viewBox="0 0 28 28" width="' + size + '" height="' + size + '" fill="none" ' +
      'stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + body + "</svg>";
    return s;
  }
  function tasteItems(v) {
    if (v === "mix") {
      var seenK = {}, out = [];
      TASTE_ORDER.forEach(function (t) {
        var it = withTaste(t).filter(function (x) { return !seenK[x.k]; })[0];
        if (it) { out.push(it); seenK[it.k] = true; }
      });
      return { show: out, count: inFormat().length };
    }
    var want = v.split(" "), all = inFormat().filter(function (it) {
      return it.taste.some(function (t) { return want.indexOf(t) > -1; });
    });
    return { show: all.slice(0, 3), count: all.length };
  }
  function optVisual(key, v) {
    if ((key === "milk" || key === "brew") && ICONS[v]) return svgIcon(ICONS[v], 34);
    if (key === "str") {
      if (v === "decaf") return svgIcon(ICONS.decaf, 34);
      var m = mk("span", "pren-fd-meter");
      m.setAttribute("aria-hidden", "true");
      for (var j = 1; j <= 3; j++) m.appendChild(mk("span", j <= STR_N[v] ? "is-on" : ""));
      return m;
    }
    if (key === "taste") {
      var ti = tasteItems(v);
      if (!ti.show.length) return null;
      var w = mk("span", "pren-fd-thumbs");
      w.setAttribute("aria-hidden", "true");
      ti.show.slice(0, 3).forEach(function (it) {
        var im = mk("img"); im.src = it.img; im.alt = ""; im.loading = "lazy";
        w.appendChild(im);
      });
      w.appendChild(mk("span", "pren-fd-thumbs-n", kinds(ti.count)));
      return w;
    }
    if (key === "cups") {
      var n = parseInt(v, 10) || 0;
      var row = mk("span", "pren-fd-cups");
      row.setAttribute("aria-hidden", "true");
      var shown = Math.min(n, 7);
      for (var i = 0; i < shown; i++) {
        var c = svgIcon(CUP, 16);
        c.className = "pren-fd-cup";
        row.appendChild(c);
      }
      if (n > 7) row.appendChild(mk("span", "pren-fd-cups-plus", "+"));
      return row;
    }
    return null;
  }
  function cupsSub(cups) {
    var g = cups * GRAMS_PER_CUP * DAYS_PER_MONTH;
    return "≈ " + kgText(g) + " per mėnesį";
  }

  function priceOf(it) { var pd = netFor(it); return pd !== null ? pd : it.p; }

  function nextStep() {
    FD.step++;
    if (FD.step > QS.length) makeResult();
    renderFinder(true);
  }
  function rateText(it) {
    if (!(it.rn >= 5 && it.ra > 0)) return "";
    return "★ " + it.ra.toFixed(1).replace(".", ",") + " (" + it.rn + ")";
  }

  function renderFinder(focus) {
    var box = el.quiz;
    if (!box) return;
    box.hidden = false;
    box.innerHTML = "";
    var top = mk("div", "pren-fd-top");
    var heading;

    if (FD.step <= QS.length) {
      var Q = QS[FD.step - 1];
      top.appendChild(mk("span", "pren-fd-n", "Mini klausimynas · " + FD.step + " iš " + QS.length));
      if (FD.step > 1) top.appendChild(mkBtn("pren-fd-back", "Atgal", function () { FD.step--; renderFinder(true); }));
      box.appendChild(top);
      var bar = mk("div", "pren-fd-bar");
      bar.setAttribute("aria-hidden", "true");
      bar.style.gridTemplateColumns = "repeat(" + QS.length + ", 1fr)";
      for (var i = 1; i <= QS.length; i++) bar.appendChild(mk("span", i <= FD.step ? "is-on" : ""));
      box.appendChild(bar);
      heading = mk("h4", "pren-fd-q", Q.h);
      box.appendChild(heading);
      if (Q.sub) box.appendChild(mk("p", "pren-fd-qsub", Q.sub));
      var opts = qOpts(Q);
      var grid = mk("div", "pren-fd-opts" + (Q.key === "cups" ? " pren-fd-opts--4" : ""));
      grid.setAttribute("role", "group");
      grid.setAttribute("aria-label", Q.h);
      var nextB = null;
      opts.forEach(function (o) {
        var on = Q.multi ? FD.tsel.indexOf(o[0]) > -1 : String(FD.a[Q.key]) === o[0];
        var b = mkBtn("pren-fd-opt" + (on ? " is-on" : ""), null, function () {
          if (Q.multi && o[0] !== "mix") {
            var at = FD.tsel.indexOf(o[0]);
            if (at > -1) FD.tsel.splice(at, 1);
            else {
              FD.tsel = FD.tsel.filter(function (x) { return x !== "mix"; });
              if (FD.tsel.length >= Q.multi) FD.tsel.shift();
              FD.tsel.push(o[0]);
            }
            FD.a.taste = FD.tsel.join(" ");
            renderFinder(false);
            var nb = box.querySelector(".pren-fd-next");
            if (nb && FD.tsel.length) nb.focus();
            return;
          }
          if (Q.multi) { FD.tsel = ["mix"]; FD.a.taste = "mix"; }
          else FD.a[Q.key] = Q.key === "cups" ? parseInt(o[0], 10) : o[0];
          if (Q.key === "cups") dailyCups = FD.a.cups;
          nextStep();
          if (Q.key === "cups") render();
        });
        b.setAttribute("aria-pressed", on ? "true" : "false");
        var vis = optVisual(Q.key, o[0]);
        if (vis) b.appendChild(vis);
        var tx = mk("span", "pren-fd-opt-x");
        tx.appendChild(mk("span", "pren-fd-opt-main", o[1]));
        var sub = Q.key === "cups" ? cupsSub(parseInt(o[0], 10)) : o[2];
        if (sub) tx.appendChild(mk("span", "pren-fd-opt-sub", sub));
        b.appendChild(tx);
        if (Q.multi && o[0] !== "mix") b.appendChild(mk("span", "pren-fd-check"));
        grid.appendChild(b);
      });
      box.appendChild(grid);
      if (Q.multi) {
        var row = mk("div", "pren-fd-acts");
        nextB = mkBtn("pren-btn pren-btn--solid pren-fd-next", "Toliau", function () {
          if (!FD.tsel.length) return;
          nextStep();
        });
        nextB.disabled = !FD.tsel.length;
        row.appendChild(nextB);
        var cnt = FD.tsel.filter(function (x) { return x !== "mix"; }).length;
        row.appendChild(mk("span", "pren-fd-hint", cnt ? "Pažymėta: " + cnt + " iš " + Q.multi : "Pažymėk bent vieną"));
        box.appendChild(row);
      }
    } else {
      var z = resultSize();
      var rows = spread(FD.res, z.total);
      top.appendChild(mk("span", "pren-fd-n", "Tau labiausiai tinka"));
      top.appendChild(mkBtn("pren-fd-back", "Atsakyti iš naujo", function () { FD.step = 1; FD.done = false; FD.qty = 0; renderFinder(true); }));
      box.appendChild(top);
      var lab = planLabel();
      heading = mk("h4", "pren-fd-q", kinds(rows.length) + ", " + packs(z.total) + (lab ? " " + lab.toLowerCase() : " per siuntą"));
      box.appendChild(heading);

      /* kiekis: kiek reikia + didesnės pakopos (CRO: matoma, kiek pigiau imant daugiau) */
      var pctNow = pctForQty(z.total);
      if (PLAN_MODE) {
        var qc = qtyChoices();
        if (qc.list.length > 1) {
          box.appendChild(mk("p", "pren-fd-qh", "Kiek kavos siųsti?"));
          var qw = mk("div", "pren-fd-qty");
          qw.setAttribute("role", "group");
          qw.setAttribute("aria-label", "Kiekis siuntoje");
          var maxPct = pctForQty(qc.list[qc.list.length - 1]);
          qc.list.forEach(function (q) {
            var pc = pctForQty(q), on = q === z.total;
            var b = mkBtn("pren-fd-qb" + (on ? " is-on" : "") + (pc === maxPct && pc > pctForQty(qc.list[0]) ? " is-best" : ""), "", function () {
              FD.qty = q; FD.done = false; resizeResult(); renderFinder(false);
            });
            b.setAttribute("aria-pressed", on ? "true" : "false");
            if (pc === maxPct && pc > pctForQty(qc.list[0])) b.appendChild(mk("span", "pren-fd-qb-flag", "Didžiausia nuolaida"));
            b.appendChild(mk("b", null, kgText(q * formatGrams())));
            b.appendChild(mk("span", "pren-fd-qb-pct", "−" + pc + "%"));
            b.appendChild(mk("span", "pren-fd-qb-s", q === qc.need ? "tiek išgeri" : packs(q)));
            qw.appendChild(b);
          });
          box.appendChild(qw);
        }
      }

      var ul = mk("ul", "pren-fd-res");
      var sum = 0, sumWas = 0;
      rows.forEach(function (r, idx) {
        var it = BY[state.format][r.k];
        var unit = priceAt(it, pctNow);
        sum += unit * r.n;
        sumWas += it.p * r.n;
        var li = mk("li", idx === 0 && rows.length > 1 ? "is-best" : null);
        var im = mk("img"); im.src = it.img; im.alt = ""; im.loading = "lazy";
        li.appendChild(im);
        var x = mk("span", "pren-fd-res-x");
        if (idx === 0 && rows.length > 1) x.appendChild(mk("span", "pren-fd-badge", "Geriausiai atitinka"));
        x.appendChild(mk("b", null, it.o + (r.n > 1 ? " ×" + r.n : "")));
        var why = whyFor(it);
        if (why) x.appendChild(mk("span", "pren-fd-why", why));
        var rt = rateText(it);
        if (rt) {
          var rs = mk("span", "pren-fd-rate", rt);
          rs.setAttribute("aria-label", "Pirkėjų įvertinimas " + it.ra.toFixed(1) + " iš 5, " + it.rn + " atsiliepimai");
          x.appendChild(rs);
        }
        li.appendChild(x);
        li.appendChild(mk("span", "pren-fd-res-p", money(unit)));
        var sw = mkBtn("pren-fd-swap", "Kita", function () { swapOne(idx); });
        sw.setAttribute("aria-label", "Pakeisti kita kava vietoj " + it.o);
        li.appendChild(sw);
        ul.appendChild(li);
      });
      box.appendChild(ul);

      var sl = mk("p", "pren-fd-sum");
      sl.appendChild(document.createTextNode("Už siuntą "));
      sl.appendChild(mk("b", null, money(sum)));
      if (sumWas > sum) sl.appendChild(mk("span", "pren-fd-save", "Sutaupai " + money(sumWas - sum) + " (−" + pctNow + "%)"));
      var stx = shipText(sum);
      if (stx) sl.appendChild(mk("span", "pren-fd-ship", stx));
      box.appendChild(sl);
      var gNext = null, kgNow = z.total * formatGrams() / 1000;
      for (var gi = 0; gi < GIFTS.length; gi++) if (kgNow + 1e-9 < GIFTS[gi].kg) { gNext = GIFTS[gi]; break; }
      if (z.total > qtyForCups(FD.a.cups || 4)) {
        box.appendChild(mk("p", "pren-fd-hint", "Kavos turėsi į valias. Jei liks, kitą siuntą galėsi praleisti."));
      } else if (gNext && pctNow >= 40) {
        box.appendChild(mk("p", "pren-fd-hint", "Nuo " + gNext.kg + " kg siuntos gausi dovaną: " + gNext.title + "."));
      }

      var acts = mk("div", "pren-fd-acts");
      if (FD.done) {
        acts.appendChild(mk("p", "pren-fd-ok", "Įdėta į siuntą. Kiekius gali keisti sąraše žemiau."));
      } else {
        acts.appendChild(mkBtn("pren-btn pren-btn--solid", "Įdėti į siuntą", function () {
          FD.done = true;
          applyRows(rows, "Pagal tavo atsakymus", true);
          renderFinder(false);
        }));
        acts.appendChild(mkBtn("pren-calc-apply", "Rodyti kitas", function () {
          makeResult();
          say("Parinktos kitos kavos.");
          renderFinder(true);
        }));
      }
      box.appendChild(acts);
    }
    if (focus && heading) {
      heading.setAttribute("tabindex", "-1");
      try { heading.focus({ preventScroll: true }); } catch (e) { heading.focus(); }
    }
  }
  /* Pasikeitus formatui rezultatas perskaiciuojamas — senos kavos kitame
     formate neegzistuoja. */
  function syncFinder() {
    if (FD.step > QS.length && FD.fmt && FD.fmt !== state.format) { makeResult(); renderFinder(false); }
  }
  renderFinder(false);

  /* ==================== KIEKIO IR DAZNIO PATARIMAS ====================
     Palygina, kiek dienu uztenka siuntos, su tuo, po kiek dienu atvyksta kita.
     Reikia zinoti puodeliu skaiciu — be jo nieko nespejama. Veiksmai keicia
     tik viena dalyka: arba bendra kieki, arba daznuma. */
  var CUPS_T = { 2: "1–2 puodelius", 4: "3–4 puodelius", 6: "5–6 puodelius", 9: "7 ir daugiau puodelių" };

  function setFreq(inp) {
    if (!inp) return;
    inp.checked = true;
    if (inp.name === "pren-plan") {
      state.planId = parseInt(inp.value, 10) || 0;
      var dd = parseInt(inp.getAttribute("data-days"), 10);
      state.freq = isFinite(dd) ? dd : null;
    } else {
      state.freq = parseInt(inp.value, 10) || null;
    }
    say("Dažnumas pakeistas: " + planLabel().toLowerCase() + ".");
    syncChoices();
    renderCalc();
    render();
  }
  /* Keicia bendra kieki, islaikydamas pasirinktas kavas: prideda maziausiai
     turinciai, atima is daugiausiai turincios, ne maziau kaip po viena. */
  function setTotal(target) {
    var a = selArr();
    if (!a.length) return;
    target = Math.max(a.length, Math.min(maxQ(), target));
    var guard = 100;
    while (sumN() < target && guard--) {
      a.slice().sort(function (x, y) { return x.n - y.n; })[0].n++;
    }
    while (sumN() > target && guard--) {
      var big = a.slice().sort(function (x, y) { return y.n - x.n; })[0];
      if (big.n <= 1) break;
      big.n--;
    }
    say("Siuntoje dabar " + packs(sumN()) + ".");
    renderCalc();
    render();
  }

  function adviceModel() {
    if (!dailyCups || !state.freq || !sumN()) return null;
    var perDay = dailyCups * GRAMS_PER_CUP;
    var F = state.freq;
    var lasts = Math.round(shipmentGrams() / perDay);
    var dur = function (d) { return d >= 45 ? "~" + String(Math.round(d / 30.4 * 2) / 2).replace(".", ",") + " mėn." : "~" + d + " d."; };
    var head = "Šios siuntos užteks " + dur(lasts) + ", o kita atvyks po " + dur(F) +
      " (skaičiuojant " + (CUPS_T[dailyCups] || dailyCups + " puodelius") + " per dieną).";
    var opts = freqOptions(), acts = [];
    var kindsNow = selArr().length;
    if (lasts < F * 0.85) {
      /* apvalinama kaip skaiciuotuve; jei to neuztenka — i virsu */
      var more = Math.round(perDay * F / formatGrams());
      if (more <= sumN()) more = Math.ceil(perDay * F / formatGrams());
      more = Math.max(kindsNow, more);
      if (more <= maxQ() && more > sumN()) {
        acts.push({ t: "Siųsti " + packsAcc(more), fn: function () { setTotal(more); } });
      }
      var faster = opts.filter(function (o) { return o.days < F && o.days <= lasts * 1.15; }).pop();
      if (faster) acts.push({ t: ltLabelFromDays(faster.days), fn: function () { setFreq(faster.input); } });
      return { kind: "short", text: "Kavos gali pritrūkti. " + head, acts: acts };
    }
    /* Nesiūlome mažinti: daugiau kavos = didesnė nuolaida. Vietoj to —
       kiek trūksta iki kitos pakopos (1–2 pakuotės) ir priminimas, kad
       siuntą galima praleisti, jei atsargų lieka. */
    var nx = PLAN_MODE ? nextTier() : null;
    if (nx) {
      var addN = Math.ceil(nx.needKg * 1000 / formatGrams() - 1e-9);
      var toN = sumN() + addN;
      if (addN >= 1 && addN <= 2 && toN <= maxQ()) {
        acts.push({ t: "Siųsti " + packsAcc(toN) + " · −" + nx.pct + "%", fn: function () { setTotal(toN); } });
      }
    }
    if (lasts > F * 1.6 && lasts - F >= 14) {
      return {
        kind: "ok",
        text: lasts > 92
          ? "Kavos turėsi į valias. Jei liks, kitą siuntą galėsi praleisti arba atidėti paskyroje."
          : "Kavos turėsi į valias: šios siuntos užteks " + dur(lasts) + " (skaičiuojant " + (CUPS_T[dailyCups] || dailyCups + " puodelius") + " per dieną). Jei kavos liks, kitą siuntą galėsi praleisti.",
        acts: acts
      };
    }
    return { kind: "ok", text: "Kiekis tinka. " + head, acts: acts };
  }

  /* Tas pats patarimas rodomas 3 ir 4 zingsnyje. Jei puodeliu skaicius
     nezinomas, perziuroje paklausiama — be daznumo keitimo. */
  function adviceNode(ask) {
    var m = adviceModel();
    if (!m) {
      /* puodelių neklausiame (lėtino užsakymą) — patarimas tik jei atsakyta klausimyne */
      return null;
    }
    var d = document.createElement("div");
    d.className = "pren-advice pren-advice--" + m.kind;
    var p = document.createElement("p");
    p.textContent = m.text;
    d.appendChild(p);
    if (m.acts.length) {
      var ac = document.createElement("div");
      ac.className = "pren-advice-acts";
      m.acts.forEach(function (a) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "pren-calc-apply"; b.textContent = a.t;
        b.addEventListener("click", a.fn);
        ac.appendChild(b);
      });
      d.appendChild(ac);
    }
    return d;
  }
  function renderAdvice() {
    if (!el.advice) return;
    el.advice.innerHTML = "";
    /* skaiciuotuvas isimtas: puodeliu klausiama cia, kai jau yra kavu */
    var n = adviceNode(true);
    el.advice.hidden = !n;
    if (!n) return;
    el.advice.className = n.className;
    while (n.firstChild) el.advice.appendChild(n.firstChild);
  }

  /* ==================== ZINGSNIAI ====================
     Vienas zingsnis = vienas sprendimas. I prieki galima tik tada, kai
     ankstesni zingsniai turi reiksmes; atgal — visada. */
  var STEPS = 4;
  var STEP_T = { 1: "formatas", 2: "dažnumas", 3: "kavų pasirinkimas", 4: "peržiūra" };
  var build = root.querySelector(".pren-build");
  /* Mygtuku yra po du (po zingsniu ir juostoje) — dirbam su sarasais. */
  var BACKS = Array.prototype.slice.call(root.querySelectorAll("[data-pren-back]"));
  var NEXTS = Array.prototype.slice.call(root.querySelectorAll("[data-pren-next]"));
  var HINTS = Array.prototype.slice.call(root.querySelectorAll("[data-pren-navHint]"));
  var panes = {}, progs = {};
  (function () {
    for (var i = 1; i <= STEPS; i++) {
      panes[i] = root.querySelector('[data-pane="' + i + '"]');
      progs[i] = root.querySelector('[data-prog="' + i + '"]');
    }
  })();

  function blockedNow() {
    if (!hasPlans()) return false;
    var pm = priceModel();
    return pm.lines.length > 0 && pm.net === null;
  }
  function stepDone(n) {
    if (n === 1) return state.fmtChosen;
    if (n === 2) return PLAN_MODE ? state.planId > 0 : state.freq > 0;
    return sumN() > 0 && !blockedNow();
  }
  function reachable(n) {
    for (var i = 1; i < n; i++) if (!stepDone(i)) return false;
    return true;
  }
  function goTo(n, quiet) {
    n = Math.max(1, Math.min(STEPS, n));
    while (n > 1 && !reachable(n)) n--;
    var changed = n !== state.step;
    state.step = n;
    setSheet(false);
    render();
    if (quiet) return;
    var p = panes[n];
    if (p) {
      var h = p.querySelector(".pren-pane-h");
      if (h) { h.setAttribute("tabindex", "-1"); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
    var anchor = el.prog || build;
    if (anchor) {
      var soft = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
      window.scrollTo({ top: anchor.getBoundingClientRect().top + window.pageYOffset - topGap(), behavior: soft });
    }
    if (changed) say("Žingsnis " + n + " iš " + STEPS + ": " + STEP_T[n] + ".");
  }
  /* lipni antraštė išnyra slenkant aukštyn ir uždengdavo žingsnių juostą */
  function topGap() {
    var hd = document.querySelector(".section-header");
    var h = hd ? hd.getBoundingClientRect().height : 0;
    return (h > 0 && h < 200 ? h : 0) + 14;
  }
  function advance() {
    if (state.step < STEPS) goTo(state.step + 1); else addToCart();
  }

  /* Grazina prie formos: narsymas pastatomas i ekrano apacia, todel virs jo
     lieka matomas ir paties zingsnio turinys. Zingsnio NEKEICIA — tai ir buvo
     problema: is juostos zmogus perstumdavo zingsni jo net nepamates. */
  /* Grazina prie formos: tas pats orientyras, kaip perejus zingsni — progreso
     juosta, po ja iskart einantis zingsnio turinys. Bandziau statyti narsyma i
     ekrano apacia, bet 3 zingsnyje sarasas ilgas ir zmogus atsidurdavo jo
     gale, o ne prie pildymo. Zingsnis NEKEICIAMAS. */
  function toForm() {
    setSheet(false);
    var soft = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    var anchor = el.prog || panes[state.step] || build;
    if (!anchor) return;
    window.scrollTo({
      top: Math.max(0, anchor.getBoundingClientRect().top + window.pageYOffset - topGap()),
      behavior: soft
    });
  }
  if (el.toForm) el.toForm.addEventListener("click", barAct);
  NEXTS.forEach(function (b) { b.addEventListener("click", advance); });
  BACKS.forEach(function (b) { b.addEventListener("click", function () { goTo(state.step - 1); }); });
  Array.prototype.forEach.call(root.querySelectorAll("[data-pren-goto]"), function (b) {
    b.addEventListener("click", function () {
      if (b.disabled) return;
      goTo(parseInt(b.getAttribute("data-pren-goto"), 10) || 1);
    });
  });

  /* Progreso juostoje rodoma ne tik zingsnio pavadinimas, bet ir pasirinkta
     reiksme — taip visa sudetis matoma be grazinimo atgal. */
  function progVal(n) {
    if (n === 1) return state.fmtChosen ? (state.format === "beans" ? "Pupelės, 1 kg" : "Malta, 250 g") : "";
    if (n === 2) return planLabel() || "";
    if (n === 3) {
      var s = sumN();
      return s ? packs(s) + ", " + kinds(selArr().length) : "";
    }
    var pm = priceModel();
    if (!pm.lines.length || (hasPlans() && pm.net === null)) return "";
    return money(hasPlans() ? pm.net : pm.base) + " už siuntą";
  }

  /* --- perziura --- */
  function mkSpan(cls, txt) {
    var e = document.createElement("span");
    e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function revFact(icoName, title, sub, step) {
    var d = document.createElement("div");
    d.className = "pren-rev-fact";
    d.appendChild(icoEl(icoName, "pren-rev-fact-ico"));
    var x = document.createElement("span");
    x.className = "pren-rev-fact-x";
    var b = document.createElement("b");
    b.textContent = title;
    x.appendChild(b);
    if (sub) {
      var s = document.createElement("span");
      s.textContent = sub;
      x.appendChild(s);
    }
    d.appendChild(x);
    if (step) {
      var e = document.createElement("button");
      e.type = "button"; e.className = "pren-rev-edit"; e.textContent = "Keisti";
      e.setAttribute("aria-label", "Keisti — " + title);
      e.addEventListener("click", function () { goTo(step); });
      d.appendChild(e);
    }
    return d;
  }

  function renderReview(ready, pm, base, net, off, pct, perMonth, oneTime, blockMsg) {
    if (!el.review) return;
    el.review.innerHTML = "";
    if (state.step !== STEPS) return;

    if (!ready) {
      var p0 = document.createElement("p");
      p0.className = "pren-rev-empty";
      p0.textContent = blockMsg || "Pasirink bent vieną kavą, ir čia pamatysi visą sudėtį.";
      el.review.appendChild(p0);
      return;
    }

    var n = sumN();
    var wrap = document.createElement("div");
    wrap.className = "pren-rev";

    /* ---- kairė: kavos su nuotraukomis ---- */
    var main = document.createElement("div");
    main.className = "pren-rev-main";

    var h1 = document.createElement("h4");
    h1.className = "pren-rev-h";
    h1.textContent = "Siuntoje " + packs(n) + (shipmentGrams() > 0 ? " · " + kgText(shipmentGrams()) : "");
    main.appendChild(h1);

    var ul = document.createElement("ul");
    ul.className = "pren-rev-items";
    pm.lines.forEach(function (r) {
      var it = r.it;
      var li = document.createElement("li");
      li.className = "pren-rev-item";

      var im = document.createElement("img");
      im.src = it.img; im.alt = ""; im.loading = "lazy";
      li.appendChild(im);

      var x = document.createElement("span");
      x.className = "pren-rev-item-x";
      var nm = document.createElement("b");
      nm.textContent = it.o;
      x.appendChild(nm);
      var sub = document.createElement("span");
      var bits = [state.format === "beans" ? "1 kg pupelių" : "250 g maltos"];
      /* daugiausiai dvi skonio zymes: su trimis eilute nesitelpa ir apkarpoma */
      it.taste.slice(0, 2).forEach(function (t) { if (TASTE_LT[t]) bits.push(TASTE_LT[t].toLowerCase()); });
      sub.textContent = bits.join(" · ");
      x.appendChild(sub);
      li.appendChild(x);

      var q = document.createElement("span");
      q.className = "pren-rev-item-q";
      q.textContent = "×" + r.n;
      li.appendChild(q);

      var pr = document.createElement("span");
      pr.className = "pren-rev-item-p";
      var pd = netFor(it);
      if (pd !== null && pd < it.p) {
        var s1 = document.createElement("s"); s1.textContent = money(it.p * r.n);
        var b1 = document.createElement("b"); b1.textContent = money(pd * r.n);
        pr.appendChild(s1); pr.appendChild(b1);
      } else {
        var b2 = document.createElement("b"); b2.textContent = money(it.p * r.n);
        pr.appendChild(b2);
      }
      li.appendChild(pr);
      ul.appendChild(li);
    });
    main.appendChild(ul);

    var revG = PLAN_MODE ? giftsFor(curKg()) : [];
    if (revG.length) {
      var gul = document.createElement("ul");
      gul.className = "pren-rev-items pren-rev-gifts";
      revG.forEach(function (g) {
        var gli = document.createElement("li");
        gli.className = "pren-rev-item pren-rev-gift";
        if (g.img) { var gim = document.createElement("img"); gim.src = g.img; gim.alt = ""; gim.loading = "lazy"; gli.appendChild(gim); }
        var gx = document.createElement("span"); gx.className = "pren-rev-item-x";
        var gb = document.createElement("b"); gb.textContent = g.title; gx.appendChild(gb);
        var gs = document.createElement("span"); gs.textContent = "Dovana už " + g.kg + " kg ir didesnę siuntą"; gx.appendChild(gs);
        gli.appendChild(gx);
        var gq = document.createElement("span"); gq.className = "pren-rev-item-q"; gq.textContent = "×1"; gli.appendChild(gq);
        var gp = document.createElement("span"); gp.className = "pren-rev-item-p";
        if (g.value > 0) { var gsv = document.createElement("s"); gsv.textContent = money(g.value); gp.appendChild(gsv); }
        var gbv = document.createElement("b"); gbv.textContent = "Dovana"; gp.appendChild(gbv);
        gli.appendChild(gp);
        gul.appendChild(gli);
      });
      main.appendChild(gul);
    }
    var nextG = null;
    for (var gi2 = 0; gi2 < GIFTS.length; gi2++) if (curKg() + 1e-9 < GIFTS[gi2].kg) { nextG = GIFTS[gi2]; break; }
    if (PLAN_MODE && nextG) {
      var gh = document.createElement("p");
      gh.className = "pren-gift-hint pren-rev-gifthint";
      var needG = (Math.round((nextG.kg - curKg()) * 100) / 100).toString().replace(".", ",");
      gh.textContent = "Dar " + needG + " kg, ir gausi dovaną: " + nextG.title + ".";
      main.appendChild(gh);
    }

    var chg = document.createElement("button");
    chg.type = "button"; chg.className = "pren-rev-edit pren-rev-edit--block";
    chg.textContent = "Keisti kavas";
    chg.addEventListener("click", function () { goTo(3); });
    main.appendChild(chg);

    var adv = adviceNode(true);
    if (adv) main.appendChild(adv);

    /* pirmos siuntos */
    var ds = dates(state.freq);
    if (ds.length) {
      var h2 = document.createElement("h4");
      h2.className = "pren-rev-h";
      h2.textContent = "Pirmos siuntos";
      main.appendChild(h2);
      var ol = document.createElement("ol");
      ol.className = "pren-rev-dates pren-rev-tl";
      ds.slice(0, 3).forEach(function (d, i) {
        var li2 = document.createElement("li");
        li2.appendChild(mkSpan("pren-rev-tl-dot"));
        li2.appendChild(mkSpan("pren-rev-tl-k", i === 0 ? "Pirma siunta" : (i + 1) + "-a siunta"));
        li2.appendChild(mkSpan("pren-rev-tl-d", MON[d.getMonth()] + " " + d.getDate() + " d."));
        ol.appendChild(li2);
      });
      main.appendChild(ol);
    }
    wrap.appendChild(main);

    /* ---- dešinė: faktai, kaina, ramybė ---- */
    var side = document.createElement("div");
    side.className = "pren-rev-side";
    var card = document.createElement("div");
    card.className = "pren-rev-card";
    card.appendChild(mkSpan("pren-rev-card-h", "Tavo prenumerata"));
    var facts = document.createElement("div");
    facts.className = "pren-rev-facts";

    facts.appendChild(revFact(
      state.format === "beans" ? "beans" : "ground",
      state.format === "beans" ? "Pupelės, 1 kg" : "Malta, 250 g",
      state.format === "beans" ? "Malsi namuose" : "Paruošta iškart",
      1));

    var spy = shipmentsPerYear(state.freq);
    var freqIco = document.createElement("span");
    var factFreq = revFact("box", planLabel() || "—", spy || "", 2);
    /* daznumo ikona — ta pati, kuria naudoja plyteles (pagal intervala) */
    var slot = factFreq.querySelector(".pren-rev-fact-ico");
    if (slot) slot.innerHTML = freqIcon(state.freq).replace('class="pren-choice-ico" ', "");
    facts.appendChild(factFreq);
    card.appendChild(facts);

    var money1 = document.createElement("div");
    money1.className = "pren-rev-money";
    var mainRow = document.createElement("p");
    mainRow.className = "pren-rev-money-main";
    if (off > 0) {
      var sW = document.createElement("s");
      sW.textContent = money(base);
      mainRow.appendChild(sW);
    }
    var strong = document.createElement("strong");
    strong.textContent = money(net);
    mainRow.appendChild(strong);
    if (pct > 0) {
      var bg = document.createElement("span");
      bg.className = "pren-rev-badge";
      bg.textContent = "−" + pct + "%";
      mainRow.appendChild(bg);
    }
    money1.appendChild(mainRow);
    var per = document.createElement("p");
    per.className = "pren-rev-money-per";
    per.textContent = oneTime ? "vienkartinis pirkimas" : "už siuntą" + (planLabel() ? ", " + planLabel().toLowerCase() : "");
    money1.appendChild(per);
    var spyNum = shipmentsPerYearNum(state.freq);
    if (off > 0 && spyNum > 0) {
      var sv = document.createElement("p");
      sv.className = "pren-rev-save";
      sv.textContent = "Sutaupai " + money(Math.round(off * spyNum)) + " per metus";
      money1.appendChild(sv);
    }
    card.appendChild(money1);

    var trust = document.createElement("ul");
    trust.className = "pren-rev-trust";
    [["truck", shipText(net) || "Siuntimas pagal parduotuvės įkainius"],
      ["pause", "Siuntą gali praleisti arba atidėti"],
      ["cancel", "Atšaukti gali bet kada"]].forEach(function (t) {
      var li3 = document.createElement("li");
      li3.appendChild(icoEl(t[0], "pren-rev-trust-ico"));
      var sp = document.createElement("span");
      sp.textContent = t[1];
      li3.appendChild(sp);
      trust.appendChild(li3);
    });
    card.appendChild(trust);
    side.appendChild(card);

    wrap.appendChild(side);
    el.review.appendChild(wrap);
  }

  function renderSteps(ready, pm, base, net, off, pct, perMonth, oneTime, blockMsg) {
    if (build) build.setAttribute("data-step", String(state.step));
    for (var s = 1; s <= STEPS; s++) {
      if (panes[s]) panes[s].hidden = s !== state.step;
      var pi = progs[s];
      if (!pi) continue;
      pi.classList.toggle("is-on", s === state.step);
      pi.classList.toggle("is-done", s < state.step && stepDone(s));
      var pb = pi.querySelector("button");
      if (pb) {
        pb.disabled = !reachable(s);
        if (s === state.step) pb.setAttribute("aria-current", "step");
        else pb.removeAttribute("aria-current");
      }
      var pv = pi.querySelector("[data-pren-progVal]");
      if (pv) pv.textContent = progVal(s);
    }
    var last = state.step === STEPS;
    /* juostos mygtuko tekstą nustato barPaint() */
    BACKS.forEach(function (b) { b.hidden = state.step === 1; });
    var nextTxt = last ? (oneTime ? "Į krepšelį (vienkartinis)" : "Į krepšelį") : "Toliau";
    var nextOff = last ? !ready : !stepDone(state.step);
    NEXTS.forEach(function (b) { b.textContent = nextTxt; b.disabled = nextOff; });

    var n = sumN();

    /* Kol nieko nesudeta, juostoje nerodom nei kainos, nei "Sudeties": rodyti
       "— uz siunta" ir tuscia skyda nera ko. Lieka tik tekstas ir, kai reikia,
       grazinimas prie formos. */
    var empty = n === 0;
    if (el.sum) {
      var priceEl = el.sum.querySelector(".pren-sumbar-price");
      if (priceEl) priceEl.hidden = empty;
      var moreEl = el.sum.querySelector(".pren-sumbar-more");
      if (moreEl) moreEl.hidden = empty;
    }
    if (el.sheet) {
      el.sheet.disabled = empty;
      if (empty) setSheet(false);
    }

    var hint;
    if (last) {
      hint = ready
        ? money(net) + " už siuntą" + (planLabel() ? ", " + planLabel().toLowerCase() : "")
        : (blockMsg || "Pasirink kavą");
    } else if (state.step === 3) {
      hint = n
        ? packs(n) + " · " + (ready ? money(net) + " už siuntą" : "pasirink kitą dažnumą")
        : "Pasirink bent vieną kavą. Kiekį nustatysi mygtukais − ir +";
    } else if (!stepDone(state.step)) {
      hint = state.step === 1
        ? "Pasirink pupeles arba maltą kavą"
        : "Pasirink, kaip dažnai siųsti";
    } else {
      hint = "Žingsnis " + state.step + " iš " + STEPS + " · " + STEP_T[state.step];
    }
    HINTS.forEach(function (h) { h.textContent = hint; });
    /* Perziuros zingsnyje visa sudetis jau ekrane, todel skydas uzdaromas —
       bet mygtukas lieka, kad juosta neprarastu savo formos. */
    if (last && el.sheetPanel && !el.sheetPanel.hidden) setSheet(false);
    renderReview(ready, pm, base, net, off, pct, perMonth, oneTime, blockMsg);
    if (barSync) barSync();
  }

  function dates(freq) {
    if (!freq) return [];
    var out = [], d = new Date();
    d.setDate(d.getDate() + 2);
    for (var i = 0; i < 4; i++) { out.push(new Date(d.getTime())); d.setDate(d.getDate() + freq); }
    return out;
  }

  /* ---------- render ---------- */
  function render() {
    var m = map();
    var total = ORDER[state.format].length;

    /* isimam tai, ko siame formate nera — bet niekada del kiekio ribos */
    state.selBy[state.format] = selArr().filter(function (r) { return !!m[r.k]; });

    /* matomumas */
    var shown = 0;
    ITEMS.forEach(function (it) {
      var okF = it.f === state.format;
      var okT = state.taste === "all" ||
        (state.taste === "other" ? it.taste.length === 0 : it.taste.indexOf(state.taste) > -1);
      it.el.hidden = !(okF && okT);
      if (okF && okT) shown++;
    });
    if (el.filterCount) {
      el.filterCount.textContent = state.taste === "all"
        ? kinds(shown)
        : "Rodoma " + shown + " iš " + total;
    }

    /* formato kortelės: kiek rūšių ir pigiausia prenumeratos kaina už pakuotę */
    if (!render.fmtMetaDone) {
      render.fmtMetaDone = true;
      Array.prototype.forEach.call(root.querySelectorAll("[data-pren-fmtmeta]"), function (m) {
        var f = m.getAttribute("data-pren-fmtmeta");
        var its = ITEMS.filter(function (it) { return it.f === f; });
        if (!its.length) { m.hidden = true; return; }
        var min = Infinity;
        its.forEach(function (it) {
          var c = it.sp.length ? Math.min.apply(null, it.sp.map(function (s) { return s.pd; })) : it.p;
          if (c < min) min = c;
        });
        m.textContent = kinds(its.length) + (isFinite(min) ? " · nuo " + money(min) + (f === "ground" ? " / 250 g" : " / kg") : "");
      });
    }
    if (el.fmtHint) el.fmtHint.hidden = true;

    var n = sumN();

    /* kiekio blokas: savarankiskame rezime kiekis yra suma, ne valdymas */
    if (el.qtyTotal) {
      paintShipbox(n);
    }
    if (el.qtyCap) {
      el.qtyCap.textContent = n >= maxQ() ? "Pasiekei ribą: daugiausia " + packs(maxQ()) + " vienoje siuntoje." : "";
      el.qtyCap.hidden = n < maxQ();
    }
    if (el.shipbox) el.shipbox.hidden = !n;

    if (el.pickHint) {
      el.pickHint.textContent = n
        ? "Pasirinkta " + packs(n) + ", " + kinds(selArr().length)
        : "Pasirink bent vieną kavą. Tos pačios kavos gali imti kelias pakuotes.";
    }
    if (el.sumTitle) {
      el.sumTitle.textContent = n
        ? packs(n) + (state.fmtChosen ? " · " + (state.format === "beans" ? "pupelės" : "malta") : "") +
          (planLabel() ? " · " + planLabel().toLowerCase() : "")
        : "Prenumerata dar nesudėta";
    }
    if (el.sumSub) {
      var lab = planLabel();
      el.sumSub.textContent = n
        ? packs(n) + (lab ? " " + lab.toLowerCase() : "") +
          (shipmentGrams() > 0 ? ", iš viso " + kgText(shipmentGrams()) + " per siuntą" : "")
        : (lab ? lab + ": kavos dar nepasirinktos" : "Kavos dar nepasirinktos");
    }

    var pm = priceModel();
    var base = pm.base;
    var oneTime = !hasPlans();
    var net = pm.net;
    var blocked = false, blockMsg = "";

    if (oneTime) {
      net = base;
    } else if (net === null) {
      if (pm.lines.length) {
        blocked = true;
        blockMsg = pm.missing[0] + " nepriskirta šiam dažnumui. Pasirink kitą dažnumą arba kitą kavą.";
      }
    }
    var off = (net === null || oneTime) ? 0 : base - net;
    var pct = (base && off > 0) ? Math.round(off / base * 100) : 0;
    /* siuntu per menesi — is vieneto, ne is dienu (zr. shipmentsPerYearNum) */
    var perMonth = state.freq ? shipmentsPerYearNum(state.freq) / 12 : NaN;
    var ready = !blocked && pm.lines.length > 0;
    BAR.ready = ready; BAR.net = net; BAR.base = base;

    /* pasirinkimu sarasas su kiekiais */
    if (el.picks) {
      el.picks.innerHTML = "";
      if (!selArr().length) {
        var p1 = document.createElement("p");
        p1.className = "pren-empty";
        p1.textContent = "Pasirink kavą iš sąrašo.";
        el.picks.appendChild(p1);
      } else {
        selArr().forEach(function (r) {
          var it = m[r.k];
          var row = document.createElement("div");
          row.className = "pren-pick";
          var im = document.createElement("img");
          im.src = it.img; im.alt = "";
          var nm = document.createElement("span");
          nm.className = "pren-pick-name";
          nm.textContent = it.o;
          var q = document.createElement("span");
          q.className = "pren-pick-qty";
          var mb = document.createElement("button");
          mb.type = "button"; mb.textContent = "−";
          mb.setAttribute("aria-label", "Mažiau " + it.o);
          mb.addEventListener("click", function (e) { e.stopPropagation(); bump(r.k, -1); });
          var out = document.createElement("output");
          out.textContent = String(r.n);
          var pb = document.createElement("button");
          pb.type = "button"; pb.textContent = "+";
          pb.setAttribute("aria-label", "Daugiau " + it.o);
          pb.disabled = sumN() >= maxQ();
          pb.addEventListener("click", function (e) { e.stopPropagation(); bump(r.k, 1); });
          q.appendChild(mb); q.appendChild(out); q.appendChild(pb);
          var pr = document.createElement("span");
          pr.className = "pren-pick-prices";
          var pdO = netFor(it);
          if (pdO !== null && pdO < it.p) {
            var sO = document.createElement("s"); sO.textContent = money(it.p * r.n);
            var bO = document.createElement("b"); bO.textContent = money(pdO * r.n);
            pr.appendChild(sO); pr.appendChild(bO);
          } else {
            pr.textContent = money(it.p * r.n);
          }
          row.appendChild(im); row.appendChild(nm); row.appendChild(q); row.appendChild(pr);
          el.picks.appendChild(row);
        });
      }
    }

    /* Eilute be reiksmes slepiama: "—" stulpelis atrode kaip klaida. */
    function hideEmpty(dd) {
      if (!dd) return;
      var row = dd.parentNode;
      if (!row || !row.classList || !row.classList.contains("pren-row")) return;
      var t = (dd.textContent || "").trim();
      row.hidden = (t === "" || t === "—");
    }

    if (el.base) el.base.textContent = (base && off > 0) ? money(base) : "";
    if (el.disc) el.disc.textContent = off > 0 ? "−" + money(off) + " (−" + pct + "%)" : "—";
    if (el.total) el.total.textContent = (blocked || !pm.lines.length) ? "—" : money(net);
    if (el.badge) {
      var showBadge = off > 0 && pct > 0;
      el.badge.hidden = !showBadge;
      el.badge.textContent = showBadge ? "−" + pct + "%" : "";
    }
    if (el.kilo) {
      var g = shipmentGrams();
      el.kilo.textContent = (!blocked && pm.lines.length && g > 0) ? money(Math.round(net / (g / 1000))) + " / kg" : "—";
    }
    if (el.year) el.year.textContent = (off > 0 && isFinite(perMonth) && perMonth > 0) ? money(Math.round(off * perMonth * 12)) : "—";
    [el.base, el.disc, el.kilo, el.year].forEach(hideEmpty);

    if (el.ship && FREESHIP) {
      var st = (ready && !blocked) ? shipText(net) : "";
      el.ship.textContent = (st || "Siuntimas Lietuvoje nemokamas nuo " + money(FREESHIP)) + ". Atšaukti gali bet kada.";
    }

    var ctaText = oneTime ? "Į krepšelį (vienkartinis pirkimas)" : "Į krepšelį";
    if (el.cta) {
      el.cta.disabled = !ready;
      if (el.ctaLabel) el.ctaLabel.textContent = ready ? ctaText : (pm.lines.length ? "Pasirink kitą dažnumą" : "Pasirink kavą");
      if (el.ctaPrice) el.ctaPrice.textContent = (ready && pm.lines.length) ? money(net) : "";
    }

    if (el.when) {
      el.when.innerHTML = "";
      var ds = dates(state.freq);
      if (!ds.length) {
        var li0 = document.createElement("li");
        li0.textContent = "Datos priklauso nuo plano.";
        el.when.appendChild(li0);
      } else {
        var BOX = '<svg viewBox="0 0 12 12" width="13" height="13" aria-hidden="true" focusable="false">' +
          '<path d="M1 3.4 6 1l5 2.4v5.2L6 11 1 8.6z" fill="none" stroke="currentColor" stroke-width="1"></path>' +
          '<path d="M1 3.4 6 5.8l5-2.4M6 5.8V11" fill="none" stroke="currentColor" stroke-width="1"></path></svg>';
        ds.forEach(function (d, i) {
          var li = document.createElement("li");
          var ico = document.createElement("span");
          ico.className = "pren-when-ico";
          ico.innerHTML = BOX;
          var a = document.createElement("span");
          a.className = "pren-when-date";
          a.textContent = MON[d.getMonth()] + " " + d.getDate() + " d.";
          var b = document.createElement("span");
          b.textContent = i === 0 ? "pirma siunta" : WD[d.getDay()];
          li.appendChild(ico); li.appendChild(a); li.appendChild(b);
          el.when.appendChild(li);
        });
      }
    }

    /* korteliu busena: kiekis rodomas ant pacios kortelės */
    ITEMS.forEach(function (it) {
      var item = m[it.k];
      var cnt = item ? countOf(it.k) : 0;
      it.el.classList.toggle("is-picked", cnt > 0);
      if (it.qtyOut) it.qtyOut.textContent = String(cnt);
      var mb2 = it.el.querySelector("[data-cq-minus]");
      var pb2 = it.el.querySelector("[data-cq-plus]");
      if (pb2) pb2.disabled = !item || sumN() >= maxQ();
      if (mb2) mb2.disabled = !item || cnt === 0;
      if (it.pick) it.pick.setAttribute("aria-label",
        (cnt > 0 ? "Pridėti dar vieną: " : "Pridėti: ") + it.o + (cnt > 0 ? " (dabar " + cnt + ")" : ""));
      var pr2 = it.el.querySelector(".pren-p");
      if (pr2 && item) {
        /* kortelėje — prenumeratos kaina, pilna perbraukta: taip kaina matoma
           renkantis, o ne tik suvestinėje */
        var pdC = netFor(item);
        pr2.innerHTML = "";
        if (pdC !== null && pdC < item.p) {
          var sC = document.createElement("s"); sC.textContent = money(item.p);
          var bC = document.createElement("b"); bC.textContent = money(pdC);
          pr2.appendChild(sC); pr2.appendChild(bC);
        } else {
          pr2.textContent = money(item.p);
        }
      }
    });
    syncModalAdd();

    if (el.warn) {
      if (oneTime) {
        el.warn.hidden = false;
        el.warn.textContent = "Prenumeratos planai dar nesukurti, todėl kaina rodoma be prenumeratos nuolaidos, " +
          "o kava bus įdėta kaip vienkartinis pirkimas.";
      } else if (blocked) {
        el.warn.hidden = false;
        el.warn.textContent = blockMsg;
      } else {
        el.warn.hidden = true;
      }
    }

    /* juostos kaina ir miniatiūros */
    if (el.total2) el.total2.textContent = (blocked || !pm.lines.length) ? "—" : money(net);
    if (el.base2) {
      el.base2.textContent = (off > 0) ? money(base) : "";
      el.base2.hidden = !(off > 0);
    }
    if (el.barThumbs) {
      el.barThumbs.innerHTML = "";
      selArr().slice(0, 4).forEach(function (r) {
        if (!m[r.k]) return;
        var im2 = document.createElement("img");
        im2.src = m[r.k].img; im2.alt = "";
        el.barThumbs.appendChild(im2);
      });
      /* dovanos juostoje — su žyma, kad matytųsi, jog jau įdėtos */
      if (PLAN_MODE) giftsFor(curKg()).forEach(function (g) {
        if (!g.img) return;
        var gi = document.createElement("span");
        gi.className = "pren-sumbar-gift";
        gi.title = "Dovana: " + g.title;
        var im3 = document.createElement("img");
        im3.src = g.img; im3.alt = "Dovana: " + g.title;
        gi.appendChild(im3);
        el.barThumbs.appendChild(gi);
      });
    }
    if (el.sheetMeta) {
      var meta = [];
      if (state.fmtChosen) meta.push(state.format === "beans" ? "Pupelės, 1 kg" : "Malta, 250 g");
      var lab3 = planLabel();
      if (lab3) meta.push(lab3.toLowerCase());
      var spy2 = shipmentsPerYear(state.freq);
      if (spy2) meta.push(spy2);
      el.sheetMeta.textContent = meta.join(" · ");
    }

    buildSets();
    syncFinder();
    renderAdvice();
    renderSteps(ready, pm, base, net, off, pct, perMonth, oneTime, blockMsg);

    if (ready) say(packs(n) + (planLabel() ? ", " + planLabel().toLowerCase() : "") + ", " + money(net) + " už siuntą.");
  }

  /* ---------- krepselis ---------- */
  var sending = false;
  function setBusy(on, label) {
    if (el.cta) el.cta.disabled = on;
    NEXTS.forEach(function (b) {
      b.disabled = on;
      if (on) b.textContent = label;
    });
    if (on && el.ctaLabel) el.ctaLabel.textContent = label;
    if (on && el.ctaPrice) el.ctaPrice.textContent = "";
  }

  function addToCart() {
    if (sending) return;
    var L = lines();
    if (!L.length) return;
    var items = [], bad = null;
    for (var i = 0; i < L.length; i++) {
      var line = { id: L[i].it.vid, quantity: L[i].n };
      var p = planFor(L[i].it);
      if (p) line.selling_plan = p.id;
      else if (PLAN_MODE) { bad = L[i].it.o; break; }
      items.push(line);
    }
    if (bad) {
      if (el.warn) {
        el.warn.hidden = false;
        el.warn.textContent = bad + " nepriskirta šiam dažnumui. Pasirink kitą dažnumą arba kitą kavą.";
      }
      return;
    }
    sending = true;
    setBusy(true, "Dedama…");
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(rootUrl + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.description) || "krepšelio klaida");
        /* į krepšelį — paskutinis patikrinimas prieš apmokėjimą (?added — patvirtinimo juosta) */
        window.location.href = rootUrl + "cart?added=1";
      })
      .catch(function (err) {
        sending = false;
        if (el.warn) {
          el.warn.hidden = false;
          el.warn.textContent = "Nepavyko įdėti į krepšelį. Pabandyk dar kartą.";
        }
        console.error("[prenumerata]", err);
        render();
      });
  }

  /* ---------- prijungimas ---------- */
  var autoT = null;
  Array.prototype.forEach.call(root.querySelectorAll('input[name^="pren-"]'), function (inp) {
    inp.addEventListener("change", function () {
      var key = inp.name.replace("pren-", "");
      if (key === "plan") {
        state.planId = parseInt(inp.value, 10) || 0;
        var dd = parseInt(inp.getAttribute("data-days"), 10);
        state.freq = isFinite(dd) ? dd : null;
      } else if (key === "freq") {
        state.freq = parseInt(inp.value, 10) || null;
      } else if (key === "format") {
        var from = state.format;
        state.format = inp.value;
        state.fmtChosen = true;
        /* perkeliam pasirinkima pagal kilme, jei naujame formate dar tuscia */
        if (!selArr().length && state.selBy[from].length) {
          var lost = [];
          state.selBy[from].forEach(function (r) {
            var src = BY[from][r.k];
            if (!src) return;
            var k2 = ORIG[state.format][norm(src.o)];
            if (k2) selArr().push({ k: k2, n: r.n }); else lost.push(src.o);
          });
          var over = sumN() - maxQ();
          while (over > 0 && selArr().length) {
            var lastRow = selArr()[selArr().length - 1];
            var take = Math.min(over, lastRow.n);
            lastRow.n -= take; over -= take;
            if (lastRow.n === 0) selArr().pop();
          }
          if (lost.length) say(lost[0] + " šiuo formatu nėra — išimta.");
        }
      } else {
        state[key] = inp.value;
      }
      syncChoices();
      renderCalc();
      render();
      /* vienas pasirinkimas žingsnyje — einame toliau patys (be papildomo paspaudimo);
         „Atgal“ ir žingsnių juosta leidžia grįžti */
      var autoStep = key === "format" ? 1 : ((key === "plan" || key === "freq") ? 2 : 0);
      if (autoStep && state.step === autoStep) {
        clearTimeout(autoT);
        autoT = setTimeout(function () { if (state.step === autoStep && stepDone(autoStep)) advance(); }, 420);
      }
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll("[data-pren-jump]"), function (b) {
    /* is hero: visada nuo pirmo zingsnio */
    b.addEventListener("click", function () {
      var t = root.querySelector("[data-pren-" + b.getAttribute("data-pren-jump") + "]");
      if (!t) return;
      var soft = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
      window.scrollTo({ top: Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - topGap()), behavior: soft });
    });
  });
  if (el.cta) el.cta.addEventListener("click", addToCart);

  /* ---------- suvestine: lipni sonine (kompiuteris) / plokste (telefonas) ----------
     Temos antgalis yra lipnus, todel soninei reikia zinoti jo auksti — kitaip
     ji atsiduria po antgaliu. Narsymo juostos auksti reikia ploksteil, kad
     ji atsistotu tiksliai virs jos. */
  var mqSheet = window.matchMedia("(max-width: 899px)");
  /* nustatoma barVisibility(); iskvieciama po kiekvieno perbraizymo, nes
     zingsnio auksits pakeicia vidinio narsymo vieta ekrane */
  var barSync = null;
  function barProgress() {
    var kg = curKg();
    /* iki 4 kg — kelias iki didžiausios nuolaidos, toliau — iki kitos dovanos */
    if (kg < 4) return { pct: Math.min(100, kg / 4 * 100), txt: null };
    for (var i = 0; i < GIFTS.length; i++) if (kg + 1e-9 < GIFTS[i].kg) {
      var prev = i ? GIFTS[i - 1].kg : 4;
      return { pct: Math.min(100, (kg - prev) / (GIFTS[i].kg - prev) * 100), txt: null };
    }
    return { pct: 100, txt: null };
  }
  function kgNum(k) { return String(Math.round(k * 100) / 100).replace(".", ","); }
  function giftShort(g) { return String(g.title || "").split(" – ")[0].replace(/^Coffee Cruise\s+/i, ""); }
  function barSubText() {
    var n = sumN();
    if (!n) return "";
    var parts = [];
    if (BAR.net !== null && BAR.base > BAR.net) parts.push("Sutaupai " + money(BAR.base - BAR.net));
    if (PLAN_MODE) {
      var nx = nextTier(), kgB = curKg(), got = giftsFor(kgB);
      /* įdėtos dovanos — visada matomos; toliau — kiek trūksta ir iki ko */
      if (got.length) { parts.length = 0; parts.push(got.length === 1 ? "Su dovana: " + giftShort(got[0]) : "Su " + got.length + " dovanomis"); }
      if (nx) parts.push("dar " + kgNum(nx.needKg) + " kg iki −" + nx.pct + "%");
      else {
        var ng = null;
        for (var i = 0; i < GIFTS.length; i++) if (kgB + 1e-9 < GIFTS[i].kg) { ng = GIFTS[i]; break; }
        if (ng) parts.push(got.length ? "+" + kgNum(ng.kg - kgB) + " kg – " + giftShort(ng) : "dar " + kgNum(ng.kg - kgB) + " kg iki dovanos: " + giftShort(ng));
      }
    }
    var s = parts.join(" · ");
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
  }
  /* vienas mygtukas: į krepšelį / toliau / tęsti pildymą */
  function barLabel() {
    if (state.step === STEPS) return BAR.ready ? "Į krepšelį · " + money(BAR.net) : "Peržiūra";
    if (BAR.formSeen && stepDone(state.step)) return "Toliau →";
    return "Tęsti pildymą";
  }
  function barAct() {
    if (state.step === STEPS) { if (BAR.ready) addToCart(); else toForm(); return; }
    if (BAR.formSeen && stepDone(state.step)) { advance(); return; }
    toForm();
  }
  function barPaint() {
    var p = barProgress();
    if (el.barProg) el.barProg.style.width = p.pct + "%";
    if (el.barSub) el.barSub.textContent = barSubText();
    if (el.barPct) {
      var on = PLAN_MODE && sumN() > 0;
      el.barPct.hidden = !on;
      if (on) el.barPct.textContent = "−" + tierPct() + "%";
    }
    if (el.toForm) el.toForm.textContent = barLabel();
  }
  /* Juostos aukstis reikalingas tik vietos rezervui po turiniu. Skaiciuojama
     be skydo — kitaip atsidarius sudeti puslapis pasistumtu. */
  function measure() {
    if (!el.sum) return;
    var rowEl = el.sum.querySelector(".pren-sumbar-in");
    var hh = rowEl ? rowEl.offsetHeight : el.sum.offsetHeight;
    root.style.setProperty("--pren-bar-h", hh + "px");
  }
  measure();
  window.addEventListener("resize", measure);
  window.addEventListener("load", measure);

  /* Juosta rodoma, kol konfiguratorius ekrane: puslapio apraymuose ir DUK
     jai nera ka rodyti, o ji uzstotu teksta. */
  /* Juosta yra PAGALBINE: pagrindinis valdymas stovi prie pat pasirinkimu.
     Todel juosta rodoma tada, kai to valdymo nebesimato ekrane — ir toliau
     lieka rodoma slenkant zemiau (salygos, DUK), kad butu matoma, kas sudeta.
     Skaiciuojama is getBoundingClientRect, o ne per IntersectionObserver: IO
     pranesimai priklauso nuo perzimejimo ciklo ir kai kuriose aplinkose
     neatkeliauja, tada juosta niekada neatsirastu. */
  (function barVisibility() {
    if (!el.sum) return;
    var inav = root.querySelector(".pren-inav");
    if (!inav) { el.sum.classList.add("is-on"); return; }
    function upd() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var b = inav.getBoundingClientRect();
      var navSeen = b.bottom > 4 && b.top < vh - 8;
      /* tuscia juosta ("dar nesudeta") nieko nepasako — rodoma tik kai yra kas rodyti */
      el.sum.classList.toggle("is-on", !navSeen && sumN() > 0);
      if (navSeen) setSheet(false);

      /* "Grizti prie pildymo" rodomas TIK kai zingsnio turinio ekrane nebera.
         Anksciau uzteko, kad nesimatytu narsymo — o treciame zingsnyje sarasas
         ilgas, tai mygtukas atsirasdavo net tada, kai zmogus kaip tik renkasi
         kavas, t. y. jau yra formoje. */
      var pane = panes[state.step];
      var formSeen = pane ? (function () {
        var pb = pane.getBoundingClientRect();
        return pb.bottom > 60 && pb.top < vh - 60;
      })() : navSeen;
      BAR.formSeen = formSeen;
      if (el.toForm) {
        el.toForm.hidden = false;
        if (el.toForm.parentNode) el.toForm.parentNode.hidden = false;
      }
      barPaint();
    }
    /* Ribojama laikmaciu, o ne requestAnimationFrame: rAF nevykdomas, kai
       skirtukas nerodomas, ir tada juostos busena uzstrigtu ties ta, kuri buvo
       uzkrovus puslapi. */
    var tmr = 0, lastRun = 0;
    function q() {
      var now = +new Date();
      if (now - lastRun > 90) { lastRun = now; upd(); return; }
      if (!tmr) tmr = setTimeout(function () { tmr = 0; lastRun = +new Date(); upd(); }, 100);
    }
    window.addEventListener("scroll", q, { passive: true });
    window.addEventListener("resize", q);
    window.addEventListener("load", q);
    barSync = q;
    upd();
  })();

  function setSheet(on) {
    if (el.sheetPanel) el.sheetPanel.hidden = !on;
    if (build) build.classList.toggle("is-sheet", !!on);
    if (el.sheet) el.sheet.setAttribute("aria-expanded", on ? "true" : "false");
    if (el.sheetLabel) el.sheetLabel.textContent = on ? "Suskleisti" : "Sudėtis";
    if (on) measure();
  }
  if (el.sheet) el.sheet.addEventListener("click", function () {
    setSheet(!!(el.sheetPanel && el.sheetPanel.hidden));
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && build && build.classList.contains("is-sheet")) setSheet(false);
  });
  mqSheet.addEventListener && mqSheet.addEventListener("change", function () { setSheet(false); measure(); });

  /* klaviatura: kaireje/desineje tarp zingsniu, kai fokusas progreso juostoje */
  if (el.prog) el.prog.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { e.preventDefault(); goTo(state.step + 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); goTo(state.step - 1); }
  });


  /* Startas be pasirinktos kavos: vedlyje kavos pasirinkimas yra tikras
     zingsnis, o ne kazkas, kas jau padaryta uz vartotoja. Kol nepasirinkta,
     "Toliau" neaktyvus ir pasakyta, ko reikia. */
  /* pradinis 3 žingsnio būdas: jei kavų dar nėra — padedame išsirinkti */
  setMode(sumN() ? "self" : "help", true);
  syncChoices();
  renderCalc();
  render();
})();


/* ==================== HERO ANIMACIJA ====================
   1) Paryškinta antraštės dalis keičiasi žodžiais iš nustatymo (visi žodžiai
      sukrauti viename tinklelio langelyje, todėl eilutės nešokinėja).
   2) Kainos kortelė pakaitomis rodo kavas su tikromis kainomis.
   Sustoja užvedus pelę; su "reduced motion" nesikeičia. */
(function () {
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  /* Raidžių banga: senas žodis išnyksta raidė po raidės (aukštyn), naujas
     atsiranda iš apačios su lengvu suliejimu, tada nusibrėžia pabraukimas.
     Nematomas ilgiausias žodis tame pačiame langelyje laiko plotį. */
  Array.prototype.forEach.call(document.querySelectorAll(".pren-hero2 h1[data-pren-rotate]"), function (h) {
    var st = h.querySelector("strong");
    var words = (h.getAttribute("data-pren-rotate") || "").split(",").map(function (w) { return w.trim(); }).filter(Boolean);
    if (!st || words.length < 2) return;
    var first = st.textContent.trim();
    words = words.filter(function (w) { return w !== first; });
    words.unshift(first);
    st.textContent = "";
    st.classList.add("pren-wave");
    var sr = document.createElement("span");
    sr.className = "pren-sr";
    sr.textContent = first;
    st.appendChild(sr);
    var ghost = document.createElement("span");
    ghost.className = "pren-wave-ghost";
    ghost.setAttribute("aria-hidden", "true");
    ghost.textContent = words.reduce(function (m, w) { return w.length > m.length ? w : m; }, "");
    st.appendChild(ghost);

    function build(w, cls) {
      var box = document.createElement("span");
      box.className = "pren-wave-w " + cls;
      box.setAttribute("aria-hidden", "true");
      Array.prototype.forEach.call(w, function (ch, k) {
        var c = document.createElement("span");
        c.className = "pren-wave-c";
        c.style.setProperty("--k", k);
        c.textContent = ch === " " ? "\u00a0" : ch;
        box.appendChild(c);
      });
      st.appendChild(box);
      return box;
    }
    var cur = build(first, "is-on is-drawn");
    var wi = 0, paused = false;
    h.addEventListener("mouseenter", function () { paused = true; });
    h.addEventListener("mouseleave", function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      var old = cur;
      old.classList.remove("is-on", "is-drawn");
      old.classList.add("is-out");
      setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); }, 1200);
      wi = (wi + 1) % words.length;
      var nw = build(words[wi], "is-in");
      cur = nw;
      /* du kadrai, kad naršyklė pradėtų nuo pradinės būsenos */
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        nw.classList.remove("is-in"); nw.classList.add("is-on");
        setTimeout(function () { nw.classList.add("is-drawn"); }, 450 + words[wi].length * 35);
      }); });
    }, 3600);
  });

  Array.prototype.forEach.call(document.querySelectorAll("[data-pren-hcard]"), function (card) {
    var list = card.querySelector("[data-pren-hclist]");
    var p = card.querySelector("p"), im = card.querySelector("img");
    if (!list || !p) return;
    var a = p.querySelector(".pren-hc-a"), b = p.querySelector("b"), c = p.querySelector(".pren-hc-b");
    var was = p.querySelector(".pren-hc-was"), off = p.querySelector(".pren-hc-off");
    /* perbraukta kaina ir nuolaida — visada matoma, kad kaina su nuolaida */
    if (!was) { was = document.createElement("s"); was.className = "pren-hc-was"; was.hidden = true; p.insertBefore(was, c); }
    if (!off) { off = document.createElement("span"); off.className = "pren-hc-off"; off.hidden = true; p.insertBefore(off, c); }
    var slides = [{ img: im ? im.currentSrc || im.getAttribute("src") : "", a: a ? a.textContent : "", p: b ? b.textContent : "", b: c ? c.textContent : "", was: was.hidden ? "" : was.textContent, off: off.hidden ? "" : off.textContent, first: true }];
    Array.prototype.forEach.call(list.querySelectorAll("li"), function (li) {
      slides.push({ img: li.getAttribute("data-img"), a: li.getAttribute("data-a"), p: li.getAttribute("data-p"), b: li.getAttribute("data-b"), was: li.getAttribute("data-was") || "", off: li.getAttribute("data-off") || "" });
    });
    if (slides.length < 2) return;
    slides.slice(1).forEach(function (s) { var pre = new Image(); pre.src = s.img; });
    var i = 0, paused = false;
    card.addEventListener("mouseenter", function () { paused = true; });
    card.addEventListener("mouseleave", function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      card.classList.add("is-swap");
      setTimeout(function () {
        i = (i + 1) % slides.length;
        var s = slides[i];
        if (im && s.img) { im.removeAttribute("srcset"); im.setAttribute("src", s.img); }
        if (a) { a.textContent = s.a; a.classList.toggle("pren-hc-name", !s.first); }
        if (b) b.textContent = s.p;
        if (c) c.textContent = s.b;
        was.textContent = s.was; was.hidden = !s.was;
        was.setAttribute("aria-label", s.was ? "Įprasta kaina " + s.was : "");
        off.textContent = s.off; off.hidden = !s.off;
        card.classList.remove("is-swap");
      }, 280);
    }, 3600);
  });
})();


/* DUK: vienu metu atidarytas vienas klausimas */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll("[data-pren-faq]"), function (box) {
    var all = box.querySelectorAll("details");
    Array.prototype.forEach.call(all, function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        Array.prototype.forEach.call(all, function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  });
})();

/* v 1792478848 */
